import { GetApp } from '../Consumos/SapGet.js'
import swal from 'sweetalert';
import CryptoJS from "crypto-js";
import { toString, toUpper } from 'lodash';

const opciones = { year: 'numeric', month: 'long', day: 'numeric' };
const hoy = new Date();

// URL base de la API Consumos. En local se puede apuntar a otro backend con REACT_APP_URL_CONSUMOS.
const URL_CONSUMOS = process.env.REACT_APP_URL_CONSUMOS || "https://consumos.talsa.com.co";

// Llama a WorkManager a través del proxy de la API Consumos (servidor a servidor).
// El navegador no puede llamar a WorkManager directamente por su configuración CORS,
// y así el token de WorkManager no viaja en el navegador. Devuelve el Response del fetch.
async function fetchWorkmanager(operacion, raw) {
  const token = await loginauth();
  return fetch(`${URL_CONSUMOS}/api/talsa/workmanager/${operacion}`, {
    method: 'POST',
    headers: { "Content-Type": "application/json", "authorization": token },
    body: raw
  });
}

export async function getProviderById(id) {
  try {
    const response = await fetch(`https://consumos.talsa.com.co/api/talsa/proveedores/getId?id=${id}`);
    const data = await response.json();

    // The API returns { d: { results: [...] } }
    const results = data.d ? data.d.results : (Array.isArray(data) ? data : [data]);

    const vector = results.map(item => {
      if (!item) return null;
      return {
        Nit: item.CTAX_ID_NR || item.Nit || "",
        Proveedor: item.CBP_UUID || item.Proveedor || "",
        Tproveedor: item.TBP_UUID || item.Tproveedor || "",
        tipo: item.CTAX_TYPE || item.tipo || "",
        Pais: item.TCOUNTRY_CODE || item.Pais || "",
        Ciudad: item.CCITY_NAME || item.Ciudad || "",
        Telefono: item.CPHONE_NR || item.Telefono || "",
        Email: item.C1BP_UUIDsEMAIL_URI || item.Email || ""
      };
    }).filter(i => i !== null);

    return vector;
  } catch (error) {
    console.error("Error fetching provider data:", error);
    return [];
  }
}

export async function Alert(Usuario, contrasena) {
  return getProviderById(Usuario);
}

export async function facturasget(facturaid) {
  const vector = [];
  return new Promise((resolve) => {
    let url = "";
    if (facturaid === "") {
      url = "sap/byd/odata/ana_businessanalytics_analytics.svc/RPZ2EEA5D25E57AC2899091A3QueryResults?$select=TIM_SUB_TYPE_C,TPAY_DESC,CIM_TRANSCURR,CIM_B_BTD_DATE,CSP_CDT_F_DATE,CIM_P_B_BTD_ID,CIM_BP_UUID,TIM_BP_UUID,KCOVERD_AMNT,KCNOT_DUE_AMNT,KCOUTSTANDING_AMNT&$top=9999&$format=json&$filter=CIM_BP_UUID  eq '" + localStorage.Proveedor + "' ";
    }
    else {
      url = "sap/byd/odata/ana_businessanalytics_analytics.svc/RPZ2EEA5D25E57AC2899091A3QueryResults?$select=TIM_SUB_TYPE_C,TPAY_DESC,CIM_TRANSCURR,CIM_B_BTD_DATE,CSP_CDT_F_DATE,CIM_P_B_BTD_ID,CIM_BP_UUID,TIM_BP_UUID,KCOVERD_AMNT,KCNOT_DUE_AMNT,KCOUTSTANDING_AMNT&$top=9999&$format=json&$filter=CIM_BP_UUID  eq '" + localStorage.Proveedor + "' and CIM_P_B_BTD_ID eq '" + facturaid + "' ";
    }
    loginauth().then((token) => {
      GetApp(url, token).then((value) => {
        JSON.parse(value).d.results.forEach(element => {
          const fechaVencimiento = new Date(Number(element.CSP_CDT_F_DATE.match(/\d+/g)[0]));
          const hoy = new Date();
          hoy.setHours(0, 0, 0, 0);

          let estado = "Pendiente de pago - Sin vencer"

          // Si KCOVERD_AMNT tiene valor (distinto de 0), se llama "Pendiente de pago" (Naranja)
          if (element.KCOVERD_AMNT < 0) {
            estado = "Pendiente de pago"
          }

          // Si la fecha está vencida, prima "Pendiente de pago - vencida" (Rojo)
          if (fechaVencimiento <= hoy) {
            estado = "Pendiente de pago - Vencida"
          }

          vector.push({
            fechaVencimiento: fechaVencimiento,
            fechaDocumento: new Date(Number(element.CIM_B_BTD_DATE.match(/\d+/g)[0])),
            socioComercial: element.TIM_BP_UUID,
            idFactura: element.CIM_P_B_BTD_ID,
            importeAtrasado: element.KCOVERD_AMNT,
            importeNoVencido: element.KCNOT_DUE_AMNT,
            importePendiente: element.KCOUTSTANDING_AMNT,
            moneda: element.CIM_TRANSCURR,
            condicion: element.TPAY_DESC == "No asignado" ? "Anticipo" : element.TPAY_DESC,
            estado: estado,
            tipodedocumento: element.TIM_SUB_TYPE_C,
            id: Math.floor(Math.random() * 9999999) + 1
          })
        })
        resolve(vector);
      })
    })
  });
}


export async function ordenesProveedor(fechaI, fechaF, estado, sede, orden) {
  return new Promise((resolve) => {
    let url = "";
    if (localStorage.TipoProveedor == "11") {
      url = "sap/byd/odata/ana_businessanalytics_analytics.svc/RPZA860C9F96C15F327F4FE90QueryResults?$select=C1ITEM_UUIDsITM_DLV_EDDT,CITM_DLV_EDDT_P,CSIV_INV_DATE,CCRTE_DATE_01,UCQUANTITY,TPRD_CATEGORY,TEMPL_RESP,TCRTE_IDT_UUID_01,TLFCYCLE_ST,CCREATION_DATE,CITM_DLV_STDT,Cs1ANsFF2AC84FCFC67BD,CREQUESTOR,TITM_LFCYCLE_ST,TCATDP_UUID,CPO_ID,CREF_PR_ID,Ts1ANsC547C9B5FE4769F,TSELLER,CPRD_SELLER_ID,CPRD_UUID,TPROD_UUID,CSELLER,TREQUESTOR,CRECEIVING_SITE,Cs1ANs6C0E8AAE61DBAD0,Cs1ANsD2247F0CDD303A3,TRECEIVING_SITE,TPROCESS_TYPE,TNET_PRC_QTY_UNT,KCDLVD_QTY,KCINVD_QTY,KCQUANTITY,KCNET_PRC_AMT,KCINVD_AMT,KCNET_AMT,KCRC_INVD_AMT,CREF_PR_ITEM_ID,CITM_ID,CDOC_TYPE,CNET_AMT_CUR&$format=json&$top=99999&$format=json&$filter=CCREATION_DATE ge datetime'" + fechaI + "T00:00:00' and CCREATION_DATE le datetime'" + fechaF + "T00:00:00'  and CLFCYCLE_ST_01 ne '1'  and CSELLER eq '" + localStorage.Proveedor + "'" + sede + " " + estado + " and CDOC_TYPE ne  '24'   " + orden + " &$orderby=CPO_ID asc , CITM_ID asc";
    } else {
      //url = "https://my360131.sapbydesign.com/sap/byd/odata/ana_businessanalytics_analytics.svc/RPZA860C9F96C15F327F4FE90QueryResults?$select=KCDLV_DATE,C1ITEM_UUIDsITM_DLV_EDDT,CITM_DLV_EDDT_P,CSIV_INV_DATE,CCRTE_DATE_01,UCQUANTITY,TPRD_CATEGORY,TEMPL_RESP,TCRTE_IDT_UUID_01,TLFCYCLE_ST,CCREATION_DATE,CITM_DLV_STDT,Cs1ANsFF2AC84FCFC67BD,CREQUESTOR,TITM_LFCYCLE_ST,TCATDP_UUID,CPO_ID,CREF_PR_ID,Ts1ANsC547C9B5FE4769F,TSELLER,CPRD_SELLER_ID,CPRD_UUID,TPROD_UUID,CSELLER,TREQUESTOR,CRECEIVING_SITE,Cs1ANs6C0E8AAE61DBAD0,Cs1ANsD2247F0CDD303A3,TRECEIVING_SITE,TPROCESS_TYPE,TNET_PRC_QTY_UNT,KCDLVD_QTY,KCINVD_QTY,KCQUANTITY,KCNET_PRC_AMT,KCINVD_AMT,KCNET_AMT,KCRC_INVD_AMT,CREF_PR_ITEM_ID,CITM_ID,CDOC_TYPE,CNET_AMT_CUR&$format=json&$top=99999&$format=json&$filter=CCREATION_DATE ge datetime'" + fechaI + "T00:00:00' and CCREATION_DATE le datetime'" + fechaF + "T00:00:00'  and CLFCYCLE_ST_01 ne '1'  and CITM_LFCYCLE_ST ne '8'  and CSELLER eq '" + localStorage.Proveedor + "'" + sede + " " + estado + "  " + orden + " and CDOC_TYPE eq  '24'   &$orderby=CPO_ID asc , CITM_ID asc";
      url = "sap/byd/odata/ana_businessanalytics_analytics.svc/RPZA860C9F96C15F327F4FE90QueryResults?$select=KCDLV_DATE,C1ITEM_UUIDsITM_DLV_EDDT,CITM_DLV_EDDT_P,CCRTE_DATE_01,UCQUANTITY,TPRD_CATEGORY,TEMPL_RESP,TCRTE_IDT_UUID_01,TLFCYCLE_ST,CCREATION_DATE,CITM_DLV_STDT,Cs1ANsFF2AC84FCFC67BD,CREQUESTOR,TITM_LFCYCLE_ST,TCATDP_UUID,CPO_ID,CREF_PR_ID,Ts1ANsC547C9B5FE4769F,TSELLER,CPRD_SELLER_ID,CPRD_UUID,TPROD_UUID,CSELLER,TREQUESTOR,CRECEIVING_SITE,Cs1ANs6C0E8AAE61DBAD0,Cs1ANsD2247F0CDD303A3,TRECEIVING_SITE,TPROCESS_TYPE,TNET_PRC_QTY_UNT,KCDLVD_QTY,KCINVD_QTY,KCQUANTITY,KCNET_PRC_AMT,KCINVD_AMT,KCNET_AMT,KCRC_INVD_AMT,CREF_PR_ITEM_ID,CITM_ID,CNET_AMT_CUR&$format=json&$top=99999&$format=json&$filter=CCREATION_DATE ge datetime'" + fechaI + "T00:00:00' and CCREATION_DATE le datetime'" + fechaF + "T00:00:00'  and CLFCYCLE_ST_01 ne '1'  and CSELLER eq '" + localStorage.Proveedor + "'" + sede + " " + estado + "  " + orden + "    &$orderby=CPO_ID asc , CITM_ID asc";
    }
    console.log(url)
    //and CDOC_TYPE eq '004' KCDLV_DATE and CPO_ID  eq '1000124'
    loginauth().then((token) => {
      //console.log(url)
      GetApp(url, token).then((value) => {
        const vector = [];
        JSON.parse(value).d.results.forEach(element => {
          let dias = 0;
          let estadoOC = "";
          Sedes(element.CRECEIVING_SITE).then((result) => {
            var fechaInicio = new Date("1990-01-01");
            var aaa = element.KCDLV_DATE - 726469;
            var fechaResultado = new Date(fechaInicio.getTime() + aaa * (24 * 60 * 60 * 1000));
            //738624 - 12155
            let diferenciaDias = 0;
            element.CSIV_INV_DATE = element.CSIV_INV_DATE == null ? getDateInSeconds() : element.CSIV_INV_DATE
            element.CITM_DLV_EDDT_P = element.CITM_DLV_EDDT_P == null ? getDateInSeconds() : element.CITM_DLV_EDDT_P


            vector.push({
              FechaCreacion: new Date(Number(element.CCREATION_DATE.match(/\d+/g)[0]) + 86400000),
              /* fechaFactura:  element.CSIV_INV_DATE === undefined ? ""  : convertirFecha(element.CSIV_INV_DATE) ,*/
              fechaentrega: new Date(Number(element.C1ITEM_UUIDsITM_DLV_EDDT.match(/\d+/g)[0]) + 86400000),
              Moneda: element.CNET_AMT_CUR,
              //tipodocumento: element.CDOC_TYPE,
              PosicionPedido: element.CITM_ID,
              IdPedido: element.CPO_ID,
              NumeroPiezaProveedor: element.CPRD_SELLER_ID,
              ProductoId: element.CPRD_UUID,
              Sede: result[0].nombre,
              IdSolicitud: element.CREF_PR_ID,
              IdPosicionDeCompra: element.CREF_PR_ITEM_ID,
              PedidoDeVentaProyecto: element.Cs1ANs6C0E8AAE61DBAD0,
              Imp: element.Cs1ANsD2247F0CDD303A3,
              CantidadEntrega: element.KCDLVD_QTY,
              ValorFacturado: element.KCINVD_AMT,
              CantidadFacturada: element.KCINVD_QTY,
              ValorNeto: element.KCNET_AMT,
              PrecioNeto: element.KCNET_PRC_AMT,
              CantidadPedida: element.KCQUANTITY,
              CantidadPenediente: element.KCQUANTITY,
              GrupoPrevisto: element.TCATDP_UUID,
              Creado: element.TCRTE_IDT_UUID_01,
              EmpResponsable: element.TEMPL_RESP,
              EstadoArticulo: element.TITM_LFCYCLE_ST === "Enviado" ? "Pendiente" : "Entregado",
              EstadoPedido: element.TLFCYCLE_ST === "Finalizado" ? "Entregado" : "Pendiente",
              Unidad: element.TNET_PRC_QTY_UNT,
              Categoria: element.TPRD_CATEGORY,
              tipo: element.TPROCESS_TYPE,
              DescProducto: element.TPROD_UUID,
              Bodega: element.TRECEIVING_SITE,
              Solicitante: element.TREQUESTOR,
              Proveedor: element.TSELLER,
              Linea: element.Ts1ANsC547C9B5FE4769F,
              CantiTipo: element.UCQUANTITY,
              dias: dias,
              estado: estadoOC,
              estadoSemaforo: estadoOC,
              id: Math.floor(Math.random() * 9999999) + 1
            })
          })

        })
        console.log(vector)
        resolve(vector.sort((a, b) => {
          const posicionA = parseInt(a.PosicionPedido);
          const posicionB = parseInt(b.PosicionPedido);

          if (posicionA < posicionB) {
            return -1;
          } else if (posicionA > posicionB) {
            return 1;
          } else {
            return 0;
          }
        }));
      });
    })

  });
}


function Sedes(dato) {
  return new Promise((resolve) => {
    const vectorSedes = [{ nombre: 'Itagui-Carrera 50 GG No 12 Sur 83 ', ciudad: 'CC1101' },
    { nombre: 'Itagui-Carrera 50 GG No 12 Sur 83', ciudad: 'CC1103' },
    { nombre: 'Bogotá-Calle 9 No 68 - 71', ciudad: 'CC1201' },
    { nombre: 'Bogotá-Calle 9 No 68 - 71', ciudad: 'CC1203' },
    { nombre: 'Cali-Carrera 1 No 45A - 71', ciudad: 'CC1301' },
    { nombre: 'Cali-Carrera 1 No 45A - 71', ciudad: 'CC1303' },
    { nombre: 'Barranquilla-Calle 93 No 46 - 168', ciudad: 'CC1401' },
    { nombre: 'Barranquilla-Calle 93 No 46 - 168', ciudad: 'CC1403' },
    { nombre: 'Bucaramanga-Calle 6 # 2-46', ciudad: 'CC1501' },
    { nombre: 'Bucaramanga-Calle 6 # 2-46', ciudad: 'CC1503' },
    { nombre: 'Dosquebradas-Carrera 7 No 43 - 224 local 3A', ciudad: 'CC1601' },
    { nombre: 'Dosquebradas-Carrera 7 No 43 - 224 local 3A', ciudad: 'CC1603' },
    { nombre: 'Cúcuta-Calle 6 # 2-46', ciudad: 'CC1701' },
    { nombre: 'Cúcuta-Calle 6 # 2-46', ciudad: 'CC1703' },
    ];
    const resultadoSede = vectorSedes.filter((subarreglo) => {
      return subarreglo.ciudad === dato;
    });
    resolve(resultadoSede)
  })
}


export async function getIDWorkmanager(nit) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "FCSCP29",
      "Filter": `C0004 like '${nit}'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "1",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;
        resolve(jsonStr)
        /* const registros = [];
         let registroActual = {};
         for (let i = 0; i < jsonStr.length - 1; i += +1) {
             const item = jsonStr[i];
             if (item.Key === 'Cod_Barras' && item.Field === 'Radicado') {
                 if (Object.keys(registroActual).length > 0) {
                     registros.push({ id: registroActual["ID de Material"], label: `${registroActual["ID de Material"]}-${registroActual["Descripción de Material"]}` });
                     Vector = [...Vector, [{ id: registroActual["ID de Material"], label: `${registroActual["ID de Material"]}-${registroActual["Descripción de Material"]}` }]]
                     registroActual = {};
                 }
             }
             registroActual[item.Field] = item.Value;
             if (i === jsonStr.length - 1) {
                 registros.push(registroActual);
             }
         }
         this.state.vectorProductos = registros;*/
      })
      .catch(error => console.log('error', error));

    // localStorage.setItem("Nit", result[0].Nit)
  })
}

export async function CambiosCantidadFechas(proveedor, producto, descripcionProducto, linea, cantidad, fecha, descripcion, precio, oc) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "BD7 Solo consulta",
      "OfficeCode": "01",
      "nextStepUser": "jeospina",
      "ProcessId": 1190,
      "Data": [
        {
          "Field": "C0001",
          "Value": `${proveedor}`,
          "Key": ""
        }, {
          "Field": "C0002",
          "Value": `${producto}`,
          "Key": ""
        }, {
          "Field": "C0003",
          "Value": `${descripcionProducto}`,
          "Key": ""
        }, {
          "Field": "C0004",
          "Value": `${linea}`,
          "Key": ""
        }, {
          "Field": "C0005",
          "Value": cantidad,
          "Key": ""
        }, {
          "Field": "C0006",
          "Value": `${fecha}`,
          "Key": ""
        }, {
          "Field": "C0007",
          "Value": `${descripcion}`,
          "Key": ""
        }, {
          "Field": "C0008",
          "Value": precio,
          "Key": ""
        }, {
          "Field": "C0009",
          "Value": oc,
          "Key": ""
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": true
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Insert", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          swal(`Ingreso la información con exito`, "GRACIAS!", "success");
          resolve(JSON.parse(result).Success)
        } else {
          swal("No se inserto el RADICADO del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}

export async function CambiosComentarioFacturas(fecha, descripcion, factura, proveedor) {
  return loginauth().then((token) => {
    return new Promise((resolve) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("authorization", token);

      let Body = `
        <div style="font-family: Arial, sans-serif; color: #333;">
          <h2 style="color: #BD1F34;">Nuevo Comentario sobre Factura</h2>
          <p><strong>Factura:</strong> ${factura}</p>
          <p><strong>Proveedor:</strong> ${proveedor}</p>
          <p><strong>Fecha:</strong> ${fecha}</p>
          <p><strong>Comentario:</strong></p>
          <div style="background-color: #f5f5f5; padding: 15px; border-radius: 5px; border-left: 4px solid #BD1F34;">
            ${descripcion}
          </div>
        </div>
      `;

      const raw = JSON.stringify({
        "html": Body,
        "to": "tesoreria@talsa.com.co",
        "subject": `Comentario Factura ${factura} - Proveedor ${proveedor}`
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://consumos.talsa.com.co/api/talsa/v1/enviarCorreos", requestOptions)
        .then(response => response.text())
        .then(result => {
          swal(`Solicitud enviada con éxito`, "GRACIAS!", "success");
          resolve(true);
        })
        .catch(error => {
          console.log('error', error);
          swal("Error al enviar la solicitud", "Intente nuevamente", "warning");
          resolve(false);
        });
    })
  })
}

export const myLocaleText = {
  // Filtros
  columnHeaderFiltersTooltipActive: (count) => `${count} filtro(s) activo(s)`,
  columnHeaderFiltersLabel: 'Filtros',
  columnHeaderFilterTooltip: 'Filtrar',
  // Ordenamiento
  columnHeaderSortIconLabel: 'Ordenar',
  columnHeaderSortClickLabel: 'Ordenar por',
  columnHeaderSortSelectedLabel: (column) => `Ordenado por ${column.field}`,
  // Menú de columnas
  columnMenuLabel: 'Menú',
  columnMenuShowColumns: 'Mostrar columnas',
  columnMenuFilter: 'Filtrar',
  columnMenuHideColumn: 'Ocultar',
  columnMenuUnsort: 'Desordenar',
  columnMenuSortAsc: 'Ordenar ascendente',
  columnMenuSortDesc: 'Ordenar descendente',
  // ... otras traducciones aquí
  filterOperatorAfter: 'Después',
  filterOperatorAnd: 'Y',
  filterOperatorBefore: 'Antes',
  filterOperatorContains: 'Contiene',
  filterOperatorEndsWith: 'Termina con',
  filterOperatorEquals: 'Igual a',
  filterOperatorGreaterThan: 'Mayor que',
  filterOperatorGreaterThanOrEqual: 'Mayor o igual que',
  filterOperatorIs: 'Es',
  filterOperatorIsEmpty: 'Está vacío',
  filterOperatorIsNotEmpty: 'No está vacío',
  filterOperatorIsNotNull: 'No es nulo',
  filterOperatorIsNull: 'Es nulo',
  filterOperatorLessThan: 'Menor que',
  filterOperatorLessThanOrEqual: 'Menor o igual que',
  filterOperatorNotContains: 'No contiene',
  filterOperatorNotEquals: 'No es igual a',
  filterOperatorOr: 'O',
  filterOperatorStartsWith: 'Empieza con',

};

//{ nombre: "SAGRILAFT LISTAS RESTRICTIVAS", codigo: "39" }]
export const vector = [{
  nombre: "2021", carpeta: [{ codigo: "31", nombre: "INFORMACIÓN GENERAL" }, { nombre: "REQUISITOS DE INSCRIPCIÓN", codigo: "32" },
  { nombre: "DOCUMENTOS LEGALES", codigo: "33" }, { nombre: "DOCUMENTOS CONTRACTUALES", codigo: "34" },
  { nombre: "COMUNICACIONES OFICIALES", codigo: "35" }, { nombre: "LISTAS DE PRECIOS PROVEEDORES", codigo: "36" }, { nombre: "VISITA ASOCIADA AL NEGOCIO", codigo: "37" },
  { nombre: "EVALUACIÓN DE PROVEEDORES", codigo: "38" }]
}
  ,
{
  nombre: "2022", carpeta: [{ codigo: "41", nombre: "INFORMACIÓN GENERAL" }, { nombre: "REQUISITOS DE INSCRIPCIÓN", codigo: "42" },
  { nombre: "DOCUMENTOS LEGALES", codigo: "43" }, { nombre: "DOCUMENTOS CONTRACTUALES", codigo: "44" },
  { nombre: "COMUNICACIONES OFICIALES", codigo: "45" }, { nombre: "LISTAS DE PRECIOS PROVEEDORES", codigo: "46" }, { nombre: "VISITA ASOCIADA AL NEGOCIO", codigo: "47" },
  { nombre: "EVALUACIÓN DE PROVEEDORES", codigo: "48" }]
}
  ,
{
  nombre: "2023", carpeta: [{ codigo: "51", nombre: "INFORMACIÓN GENERAL" }, { nombre: "REQUISITOS DE INSCRIPCIÓN", codigo: "52" },
  { nombre: "DOCUMENTOS LEGALES", codigo: "53" }, { nombre: "DOCUMENTOS CONTRACTUALES", codigo: "54" },
  { nombre: "COMUNICACIONES OFICIALES", codigo: "55" }, { nombre: "LISTAS DE PRECIOS PROVEEDORES", codigo: "56" }, { nombre: "VISITA ASOCIADA AL NEGOCIO", codigo: "57" },
  { nombre: "EVALUACIÓN DE PROVEEDORES", codigo: "58" }]
},
{
  nombre: "2024", carpeta: [{ codigo: "61", nombre: "INFORMACIÓN GENERAL" }, { nombre: "REQUISITOS DE INSCRIPCIÓN", codigo: "62" },
  { nombre: "DOCUMENTOS LEGALES", codigo: "63" }, { nombre: "DOCUMENTOS CONTRACTUALES", codigo: "64" },
  { nombre: "COMUNICACIONES OFICIALES", codigo: "65" }, { nombre: "LISTAS DE PRECIOS PROVEEDORES", codigo: "66" }, { nombre: "VISITA ASOCIADA AL NEGOCIO", codigo: "67" },
  { nombre: "EVALUACIÓN DE PROVEEDORES", codigo: "68" }]
}, {
  nombre: "2025", carpeta: [{ codigo: "71", nombre: "INFORMACIÓN GENERAL" }, { nombre: "REQUISITOS DE INSCRIPCIÓN", codigo: "72" },
  { nombre: "DOCUMENTOS LEGALES", codigo: "73" }, { nombre: "DOCUMENTOS CONTRACTUALES", codigo: "74" },
  { nombre: "COMUNICACIONES OFICIALES", codigo: "75" }, { nombre: "LISTAS DE PRECIOS PROVEEDORES", codigo: "76" }, { nombre: "VISITA ASOCIADA AL NEGOCIO", codigo: "77" },
  { nombre: "EVALUACIÓN DE PROVEEDORES", codigo: "78" }]
},
{
  nombre: "INFORMACIÓN TÉCNICA", carpeta: [{ codigo: "81", nombre: "MANUALES" }, { nombre: "DESPIECES", codigo: "82" },
  { nombre: "LECCIONES APRENDIDAS", codigo: "83" }]
},
{
  nombre: "TÉCNICO LIDER DE MARCA", carpeta: [{ codigo: "30", nombre: "TECNICO" }]
}]

export async function datosDeArchivoWM(codigo) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify(
      {
        "BarCode": `${localStorage.Radicado}`,
        "DirectoryCode": `${codigo}`,
        "Header": {
          "User": "Citalsa",
          "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
        }
      });
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetFileCodes", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).FileProperties;
        resolve(jsonStr)
      })
      .catch(error => console.log('error', error));

  })
}

export async function datosDeArchivoWMRevision(codigo) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify(
      {
        "BarCode": `${codigo}`,
        "DirectoryCode": '00',
        "Header": {
          "User": "Citalsa",
          "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
        }
      });
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetFileCodes", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).FileProperties;
        resolve(jsonStr)
      })
      .catch(error => console.log('error', error));

  })
}

export async function abrirPdf(id) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify(
      {

        "Header": {
          "User": "Citalsa",
          "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
        },
        "FileCode": id
      });
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetBase64StringFile", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).File;
        resolve(jsonStr)
      })
      .catch(error => console.log('error', error));

  })
}

export async function DatosPDF(proveedor, nombreArchivo, base64) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "BD9 Solo Consulta",
      "OfficeCode": "01",
      "nextStepUser": "CPENUELA",
      "ProcessId": 1196,
      "Data": [
        {
          "Field": "C0001",
          "Value": `${proveedor}`
        }, {
          "Field": "C0002",
          "Value": `${nombreArchivo}`
        }, {
          "Field": "C0003",
          "Value": `${localStorage.Proveedor}`
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": true
    });
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Insert", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          swal(`Ingreso la información con exito`, "GRACIAS!", "success");
          resolve(JSON.parse(result).Success)
          ingresoPDFWorkmanager(base64, nombreArchivo, ".pdf", JSON.parse(result).BarCode)
        } else {
          swal("No se inserto el RADICADO del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}


export async function GetDocumentosRevision() {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "BD9 Solo Consulta",
      "Filter": `C0003 like '${localStorage.Proveedor}' and Estado != 2`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "999",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;
        const registros = [];
        let registroActual = { "Radicado": null };
        let nombreArchivo = null;
        for (let i = 0; i < jsonStr.length; i++) {
          const item = jsonStr[i];
          if (item.Key === 'Cod_Barras' && item.Field === 'Radicado') {
            if (registroActual.Radicado) {
              registros.push({ id: registroActual.Radicado, label: nombreArchivo || 'Archivo en revisión' });
            }
            registroActual = { "Radicado": item.Value };
            nombreArchivo = null;
          } else {
            registroActual[item.Field] = item.Value;
            if (item.Field === 'Nombre del archivo') {
              nombreArchivo = item.Value;
            }
          }
        }
        if (registroActual.Radicado) {
          registros.push({ id: registroActual.Radicado, label: nombreArchivo || 'Archivo en revisión' });
        }

        resolve(registros);
      })
      .catch(error => console.log('error', error));
  })
}


export async function DatosProveedoresInternacional(Archivo, Campos) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "OperationUser": "VFORERO",
      "FormCode": "FCSCP32",
      "OfficeCode": "01",
      "nextStepUser": "TRAMIREZ",
      "ProcessId": 1271,
      "Data": [
        {
          "Field": "C0001",
          "Value": `1015415613 | FORERO BLANCO VANESSA`
        },
        {
          "Field": "C0002",
          "Value": `CADENA DE SUMINISTROS`
        },
        {
          "Field": "C0003",
          "Value": `ANTIOQUIA`
        },
        {
          "Field": "C0004",
          "Value": `EUROPA`
        },
        {
          "Field": "C0035",
          "Value": `N/A`
        },
        {
          "Field": "C0044",
          "Value": `${Campos.FIRSTNAME}`
        },
        {
          "Field": "C0045",
          "Value": `${Campos.LASTNAME}`
        },
        {
          "Field": "C0046",
          "Value": `${Campos.PASAPORTENUMBER}`
        },
        {
          "Field": "C0047",
          "Value": `${Campos.ISSUEDIN}`
        },
        {
          "Field": "C0048",
          "Value": `${Campos.EXPEDITIONDATE}`
        },
        {
          "Field": "C0049",
          "Value": `${Campos.ADDRESS}`
        },
        {
          "Field": "C0050",
          "Value": `${Campos.CITY}`
        },
        {
          "Field": "C0051",
          "Value": `${Campos.PHONE}`
        },
        {
          "Field": "C0052",
          "Value": `${Campos.CELLPHONE}`
        },
        {
          "Field": "C0053",
          "Value": `${Campos.COUNTRY}`
        },
        {
          "Field": "C0054",
          "Value": `${Campos.EMAIL}`
        },
        {
          "Field": "C0055",
          "Value": `${Campos.RAZONSOCIAL}`
        },
        {
          "Field": "C0056",
          "Value": `${Campos.NIT}`
        },
        {
          "Field": "C0057",
          "Value": `${Campos.DIRECCIoNOFICINAPRINCIPAL}`
        },
        {
          "Field": "C0058",
          "Value": `${Campos.PAIS}`
        },
        {
          "Field": "C0059",
          "Value": `${Campos.CIUDAD}`
        },
        {
          "Field": "C0060",
          "Value": `${Campos.TELEFONOOFICINAPRINCIPAL}`
        },
        {
          "Field": "C0061",
          "Value": `${Campos.CORREOOFICINAPRINCIPAL}`
        },
        {
          "Field": "C0062",
          "Value": `${Campos.DIRECCIoNSUCURSALOAGENCIA}`
        },
        {
          "Field": "C0063",
          "Value": `${Campos.PAISSUCURSAL}`
        },
        {
          "Field": "C0064",
          "Value": `${Campos.CIUDADSUCURSAL}`
        },
        {
          "Field": "C0065",
          "Value": `${Campos.TELEFONOSUCURSAL}`
        },
        {
          "Field": "C0066",
          "Value": `${Campos.CORREOSUCURSAL}`
        },
        {
          "Field": "C0067",
          "Value": `${Campos.FECHACONSTITUCIoNDELACOMPANIA}`
        },
        {
          "Field": "C0068",
          "Value": String(Campos.BASC)
        },
        {
          "Field": "C0069",
          "Value": String(Campos.ISO28001)
        },
        {
          "Field": "C0070",
          "Value": String(Campos.OEA)
        },
        {
          "Field": "C0071",
          "Value": `${Campos.OTROCERTIFICADO}`
        },
        {
          "Field": "C0072",
          "Value": String(Campos.NINGUNO)
        },
        {
          "Field": "C0073",
          "Value": `${Campos.LAVADODEACTIVOS}`
        },
        {
          "Field": "C0074",
          "Value": String(Campos.LAVADODEACTIVOSNOAPLICA)
        },
        {
          "Field": "C0075",
          "Value": String(Campos.ETICAEMPRESARIAL)
        },
        {
          "Field": "C0076",
          "Value": `${Campos.Sociosoaccionistas}`
        },
        {
          "Field": "C0077",
          "Value": String(Campos.FUNCIONARIOPUBLICO)
        },
        {
          "Field": "C0078",
          "Value": String(Campos.ADMINISTRARECURSOSPUBLICOS)
        },
        {
          "Field": "C0079",
          "Value": String(Campos.RECONOCIMIENTOPUBLICO)
        },
        {
          "Field": "C0080",
          "Value": String(Campos.TRANSACCIONESMONEDAEXTRANJERA)
        },
        {
          "Field": "C0081",
          "Value": `${Campos.ACTIVIDADENOPERACIONES}`
        },
        {
          "Field": "C0082",
          "Value": `${Campos.PRODUCTOS}`
        },
        {
          "Field": "C0083",
          "Value": `${Campos.NOMBRESOLICITANTE}`
        },
        {
          "Field": "C0084",
          "Value": `${Campos.DOCUMENTO}`
        },
        {
          "Field": "C0087",
          "Value": `${Campos.TIPO_VINCULACION}`
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": true
    });

    console.log("Payload International:", raw);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Insert", requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log("Response International:", result);
        if (result.Success === true) {
          const radicado = result.BarCode;

          // Subir archivos adjuntos usando la función correcta
          if (Archivo && Array.isArray(Archivo) && Archivo.length > 0) {
            const uploadPromises = Archivo
              .filter(element => element && element.base64)
              .map(element => ingresoPDFWorkmanager(element.base64, element.tipo || "Archivo Proveedor", element.ext || ".pdf", radicado));

            Promise.all(uploadPromises)
              .then(() => console.log("Todos los adjuntos internacionales se subieron con éxito"))
              .catch(err => console.error("Error al adjuntar archivos:", err));
          }

          swal(`Information entered successfully`, "THANK YOU!", "success");
          resolve(result.workflowId);
        } else {
          swal("The registry was not inserted! " + (result.Message || ""), "Validate the information!", "warning");
          resolve("");
        }
      })
      .catch(error => {
        console.error('Error Internacional:', error);
        swal("Connection error", "Could not contact WorkManager", "error");
        resolve("");
      });
  })
}

export async function DatosProveedores(Solicitante, Proceso, Sucursal, ServicioPrestado, TipoDeNegociacion, TipoDeCompra, idregisto, Archivo, Campos) {

  return new Promise((resolve) => {
    // Construcción del objeto JSON principal para el registro
    const raw = JSON.stringify({
      "OperationUser": "VFORERO",
      "FormCode": "FCSCP26",
      "OfficeCode": "01",
      "nextStepUser": "TRAMIREZ",
      "ProcessId": 1269,
      "Data": [
        {
          "Field": "C0001",
          "Value": "1015415613 | FORERO BLANCO VANESSA"
        }, {
          "Field": "C0002",
          "Value": "CADENA DE SUMINISTRO"
        }, {
          "Field": "C0003",
          "Value": `${Sucursal}`
        }, {
          "Field": "C0014",
          "Value": `${ServicioPrestado}`
        }, {
          "Field": "C0035",
          "Value": `${TipoDeNegociacion}`
        }, {
          "Field": "C0036",
          "Value": `${TipoDeCompra}`
        }, {
          "Field": "C0040",
          "Value": `${idregisto}`
        }, {
          "Field": "C0041",
          "Value": `${Campos.NOMBREINFORMACIONGENERAL}`
        }, {
          "Field": "C0042",
          "Value": `${Campos.APELLIDOINFORMACIONGENERAL}`
        }, {
          "Field": "C0043",
          "Value": `${Campos.TIPODEDOCUMENTOINFORMACIONGENERAL}`
        }, {
          "Field": "C0044",
          "Value": `${Campos.NUMEROINFORMACIONGENERAL}`
        }, {
          "Field": "C0045",
          "Value": `${Campos.EXPEDIDAEN}`
        }, {
          "Field": "C0046",
          "Value": `${Campos.FECHADEEXPEDICION}`
        }, {
          "Field": "C0047",
          "Value": `${Campos.DIRECCIONIFORMACIONGENERAL}`
        }, {
          "Field": "C0048",
          "Value": `${Campos.CIUDADINFORMACIONGENERAL}`
        }, {
          "Field": "C0049",
          "Value": `${Campos.TELEFONOINFORMACIONGENERAL}`
        }, {
          "Field": "C0050",
          "Value": `${Campos.CELULARINFORMACIONGENERAL}`
        }, {
          "Field": "C0051",
          "Value": `${Campos.CODIGOCIIUACTIVIDAD}`
        }, {
          "Field": "C0052",
          "Value": `${Campos.EMAILACTIVIDAD1}`
        }, {
          "Field": "C0053",
          "Value": `${Campos.OCUPACIONACTIVIDAD}`
        }, {
          "Field": "C0054",
          "Value": `${Campos.EMPRESAACTIVIDAD}`
        }, {
          "Field": "C0055",
          "Value": `${Campos.CARGOACTIVIDAD}`
        }, {
          "Field": "C0056",
          "Value": `${Campos.TIPODEEMPRESAACTIVIDAD}`
        }, {
          "Field": "C0057",
          "Value": `${Campos.DIRECCIONEMPRESAACTVIDAD}`
        }, {
          "Field": "C0058",
          "Value": `${Campos.PAISACTIVIDAD}`
        }, {
          "Field": "C0059",
          "Value": `${Campos.TELEFONOACTIVIDAD}`
        }, {
          "Field": "C0060",
          "Value": `${Campos.EMAILACTIVIDAD}`
        }, {
          "Field": "C0061",
          "Value": `${Campos.BASC}` // bool
        }, {
          "Field": "C0062",
          "Value": `${Campos.ISO28001}` // bool
        }, {
          "Field": "C0063",
          "Value": `${Campos.OEA}` // bool
        }, {
          "Field": "C0064",
          "Value": `${Campos.OTROSCERTIFICADOSACTIVIDAD}`
        }, {
          "Field": "C0065",
          "Value": `${Campos.NINGUNCERTIFICADO}` // bool
        }, {
          "Field": "C0066",
          "Value": `${Campos.FUNCIONARIOPUBLICO}` // bool
        }, {
          "Field": "C0067",
          "Value": `${Campos.RECURSOSPUBLICOS}` // bool
        }, {
          "Field": "C0068",
          "Value": `${Campos.RECONOCIMIENTOPUBLICO}` // bool
        }, {
          "Field": "C0069",
          "Value": `${Campos.GRANCONTRIBUYENTE}` // bool
        }, {
          "Field": "C0070",
          "Value": `${Campos.RESOLUCIONGRANCONTRIBUYENTE}`
        }, {
          "Field": "C0071",
          "Value": `${Campos.FECHAGRANCONTRIBUYENTE}`
        }, {
          "Field": "C0072",
          "Value": `${Campos.RESPONSABLEDERENTA}` // bool
        }, {
          "Field": "C0073",
          "Value": `${Campos.RESOLUCIONRENTA}`
        }, {
          "Field": "C0074",
          "Value": `${Campos.FECHARENTA}`
        }, {
          "Field": "C0075",
          "Value": `${Campos.CIUDADICA}`
        }, {
          "Field": "C0076",
          "Value": `${Campos.TARIFAX1000}`
        }, {
          "Field": "C0077",
          "Value": `${Campos.AUTORETENEDORICA}` // bool
        }, {
          "Field": "C0078",
          "Value": `${Campos.RESOLUCIONICA}`
        }, {
          "Field": "C0079",
          "Value": `${Campos.FECHAICA}`
        }, {
          "Field": "C0080",
          "Value": `${Campos.TOTALACTIVOS}`
        }, {
          "Field": "C0081",
          "Value": `${Campos.TOTALPASIVOS}`
        }, {
          "Field": "C0082",
          "Value": `${Campos.PATRIMINIO}`
        }, {
          "Field": "C0083",
          "Value": `${Campos.OPERACIONESEXTRANJERAS}` // bool
        }, {
          "Field": "C0084",
          "Value": `${Campos.TIPODEOPERACION}`
        }, {
          "Field": "C0085",
          "Value": `${Campos.OTROTIPODEOPERACION}`
        }, {
          "Field": "C0086",
          "Value": `${Campos.TABLADEPRODUCTOS}`
        }, {
          "Field": "C0087",
          "Value": `${Campos.NOMBRESOLICITANTE}`
        }, {
          "Field": "C0088",
          "Value": `${Campos.FIRMASOLICITANTE}` // base64
        }, {
          "Field": "C0089",
          "Value": `${Campos.DOCUMENTOSOLICITANTE}`
        }, {
          "Field": "C0090",
          "Value": `${Campos.RAZONSOCIAL}`
        }, {
          "Field": "C0091",
          "Value": `${Campos.NITDETALLEACTIVIDAD}`
        }, {
          "Field": "C0092",
          "Value": `${Campos.ID}`
        }, {
          "Field": "C0093",
          "Value": `${Campos.ACTIVIDADECONOMICA}`
        }, {
          "Field": "C0094",
          "Value": `${Campos.DIRECCIONOFINAPRINCIPAL}`
        }, {
          "Field": "C0095",
          "Value": `${Campos.CIUDADOFICINAPRINCIPAL}`
        }, {
          "Field": "C0096",
          "Value": `${Campos.PAISOFICINAPRINCIPAL}`
        }, {
          "Field": "C0097",
          "Value": `${Campos.TELEFONOPRINCIPAL}`
        }, {
          "Field": "C0098",
          "Value": `${Campos.CORREOCOMERCIAL1}`
        }, {
          "Field": "C0099",
          "Value": `${Campos.DIRECCIONSUCURSAL}`
        }, {
          "Field": "C0100",
          "Value": `${Campos.CIUDADSUCURSAL}`
        }, {
          "Field": "C0101",
          "Value": `${Campos.PAISSUCURSAL}`
        }, {
          "Field": "C0102",
          "Value": `${Campos.TELEFONOSUCURSAL}`
        }, {
          "Field": "C0103",
          "Value": `${Campos.CORREOPAGOS}`
        }, {
          "Field": "C0104",
          "Value": `${Campos.NOMBRESYAPELLIDOSDEQUIENDILIGENCIAELFORMATO}`
        }, {
          "Field": "C0105",
          "Value": `${Campos.CARGOFORMATO}`
        }, {
          "Field": "C0106",
          "Value": `${Campos.NOMBRECOMERCIAL}`
        }, {
          "Field": "C0107",
          "Value": `${Campos.CORREOCOMERCIAL2}`
        }, {
          "Field": "C0108",
          "Value": `${Campos.NOMBRECONTABILIDAD}`
        }, {
          "Field": "C0109",
          "Value": `${Campos.CORREOCONTABILIDAD}`
        }, {
          "Field": "C0110",
          "Value": `${Campos.NOMBRETESORERIA}`
        }, {
          "Field": "C0111",
          "Value": `${Campos.CORREOTESORERIA}`
        }, {
          "Field": "C0112",
          "Value": `${Campos.LAVADODEACTIVOS}` // bool
        }, {
          "Field": "C0113",
          "Value": `${Campos.LAVADODEACTIVOSOTROS}`
        }, {
          "Field": "C0114",
          "Value": `${Campos.ETICAEMPRESARIAL}` // 'Aceptado' | 'Rechazado'
        }, {
          "Field": "C0115",
          "Value": `${Campos.FECHACONSTITUCION}`
        }, {
          "Field": "C0116",
          "Value": `${Campos.CATEGORIAPRODUCTO}`
        }, {
          "Field": "C0117",
          "Value": `${Campos.TIPODEPRODUCTO}`
        }, {
          "Field": "C0123",
          "Value": `${Campos.TIPO_VINCULACION}`
        }, {
          "Field": "C0118",
          "Value": `${Campos.TIPOPROVEEDOR}` // 'natural' | 'juridica'
        }, {
          "Field": "C0119",
          "Value": `${Campos.NIT}`
        }, {
          "Field": "C0120",
          "Value": `${Campos.REGIMEN}` // '11'=comun | '12'=simple
        }
      ],
      "CheckWorkflow": true
    });

    console.log("Objeto enviado a WorkManager (DatosProveedores):", JSON.stringify(raw));

    // 1. Inserción del Registro Principal
    fetchWorkmanager("Forms/Form_Insert", raw)
      .then(response => response.json())
      .then(result => {
        console.log("Response Insert:", result);

        if (result.Success === true) {
          const radicado = result.BarCode;

          // 2. Inserción de Archivos (si existen)
          if (Archivo && Array.isArray(Archivo) && Archivo.length > 0) {
            const uploadPromises = Archivo
              .filter(element => element && element.base64) // Evita subir nulls o base64 vacíos
              .map(element => {
                // Aquí usamos la función que sí arma bien el JSON para Form_AttachFiles
                return ingresoPDFWorkmanager(element.base64, element.tipo || "Archivo Proveedor", element.ext || ".pdf", radicado);
              });

            Promise.all(uploadPromises)
              .then(() => console.log("Todos los adjuntos extra se subieron con éxito"))
              .catch(err => console.error("Error al adjuntar archivos:", err));
          }

          swal("Ingreso Exitoso", "Se guardó la información y se procesaron los adjuntos.", "success");
          resolve(result.workflowId);
        } else {
          swal("Error", "No se pudo ingresar el formulario. " + (result.Message || ""), "error");
          resolve("");
        }
      })
      .catch(error => {
        console.error('Error Crítico:', error);
        swal("Error de conexión", "No se pudo contactar con WorkManager", "error");
        resolve("");
      });
  });
}


export async function ingresoPDFWorkmanager(Dato, nombre, ext, radicado) {
  return new Promise((resolve) => {
    // Limpia cualquier prefijo de "data:[mime-type];base64," para asegurar que WorkManager reciba Base64 puro
    if (Dato && Dato.includes("base64,")) {
      Dato = Dato.split("base64,")[1];
    }
    const raw = JSON.stringify({
      "OperationUser": "administrador",
      "BarCode": `${radicado}`,
      "Files": [
        {
          "Base64String": `${Dato}`,
          "Ext": `${ext}`,
          "Description": `${nombre}`,
          "DocumentTypeCode": "00",
          "DirectoryCode": "00",
          "Version": "1"
        }
      ],
      "CheckWorkflow": false
    });

    fetchWorkmanager("Forms/Form_AttachFiles", raw)
      .then(response => response.text())
      .then(result => {
        console.log("Response PDF Upload (Raw):", result);
        if (JSON.parse(result).Success === true) {
          swal("Inserto el PDF...!", "Espere que salgan las demás alertas!", "success");
          resolve(radicado)
        } else {
          swal("No se inserto el PDF del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}

export async function encrypt(value) {
  const key = "Citalsa";
  const encrypted = CryptoJS.AES.encrypt(value, key).toString();
  if (encrypted.includes('+')) {
    return encrypt(value);
  }
  return encrypted;
}

export async function decrypt(encrypted) {
  const key = "Citalsa";
  const decrypted = CryptoJS.AES.decrypt(encrypted, key).toString(CryptoJS.enc.Utf8);
  return decrypted;
}


export async function getIDWorkmanagerRegistroProveedores(nit) {
  return new Promise((resolve) => {
    const raw = JSON.stringify({
      "FormCode": "FCSCP26",
      "Filter": `C0040 like '${nit}'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "1",
      "CheckWorkflow": false
    });

    fetchWorkmanager("Forms/Form_GetData", raw)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data || [];
        resolve(jsonStr)
      })
      .catch(error => console.log('error', error));
  })
}

export async function getIDWorkmanagerRegistroProveedoresInternacional(nit) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "FCSCP32",
      "Filter": `C0046 like '${nit}'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "1",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;
        resolve(jsonStr)
      })
      .catch(error => console.log('error', error));
  })
}


export async function EnviarCorreo(correo, contrasena, asunto) {
  return new Promise((resolve) => {
    loginauth().then((token) => {
      const myHeaders = new Headers();
      /*let Imagen = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAi8AAAAvCAIAAACkKb06AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADHSURBVHhe7dUxAQAgDMCwgX/P48FDn+SphJ7dHQBI3V8A6LgRAD03AqDnRgD03AiAnhsB0HMjAHpuBEDPjQDouREAPTcCoOdGAPTcCICeGwHQcyMAem4EQM+NAOi5EQA9NwKg50YA9NwIgJ4bAdBzIwB6bgRAz40A6LkRAD03AqDnRgD03AiAnhsB0HMjAHpuBEDPjQDouREAPTcCoOdGAPTcCICeGwHQcyMAem4EQM+NAOi5EQA9NwKg50YA9NwIgJ4bAVCbeZB+A1vrP7hFAAAAAElFTkSuQmCC";
      Imagen = Imagen.replace("data:image/png;base64,", "")*/
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("authorization", token);
      let Body = "<table style='background-color: #000000; padding: 0 20px !important;' role='presentation' width='100%' border='0' cellspacing='0' cellpadding='0' data-gmail-template='body' contenteditable='false'><tbody><tr height='0'><td colspan='3'><span style='padding-top: 0; font-size: 0; line-height: 0; color: #000000; background-color: #000000; mso-hide: all; display: none; overflow: hidden; max-height: 0;' data-gmail-template='preview-text'></span></td></tr><tr><td></td><td align='center' valign='top' width='600'><table width='600' border='0' cellspacing='0' cellpadding='0' style='width: 100%; max-width: 600px;background-color: #000000;' bgcolor='#000000' role='presentation'><tbody><tr><td data-gmail-template='content-parent'><style>@media only screen and (max-width: 480px) { .oEQ55c { width: 100% !important;} .zhwgeb { width: auto !important;} .MHCHNe { max-width: 100% !important;} } </style><table width='100%' border='0' cellspacing='0' cellpadding='0' role='presentation'><tbody><tr><td><table data-gmail-template='header' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: collapse; background: #fff; background-color: #fff; width: 100%; ' bgcolor='#fff' width='100%' aria-label='Encabezado' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; background-color: #fff; vertical-align: top; ' width='100%' bgcolor='#fff' valign='top'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 26px 20px; word-break: break-word; '><img data-surl='cid:ii_liaq79cj0' src='blob:https://mail.google.com/d2ef7ad6-9dfb-46fa-9e5c-259b944d9baf' alt='Marcador de posición de imagen' data-gmail-template='logo-image' style='-ms-interpolation-mode: bicubic; display: block; width: auto; max-width: 200px; height: auto; max-height: 100px; outline: none; text-decoration: none;' width='178' height='100' tabindex='1' draggable='false' class='lCsUvc aog TbVst'></td></tr></tbody></table></div></td></tr></tbody></table></td></tr></tbody></table><table width='100%' border='0' cellspacing='0' cellpadding='0' role='presentation'><tbody><tr><td><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: collapse; background-color: white; width: 100%; ' bgcolor='white' width='100%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding-bottom: 30px; text-align: center; ' align='center'><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' width='100%' style='border-collapse: collapse'><tbody><tr><td style=' border-collapse: collapse; vertical-align: middle; ' valign='middle'><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; ' width='100%'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 0 10px;word-break: break-word; '><div data-gmail-template='text-slot' style=' font-family: arial,sans-serif; font-weight: 400; font-size: 32px; letter-spacing: 0; line-height: normal; text-align: center; color: #202124; ' contenteditable='true' tabindex='1' role='textbox' class='anG TbVst'>Nueva contraseña Portal Proveedores</div></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' width='100%' style='border-collapse: collapse'><tbody><tr><td style=' border-collapse: collapse; vertical-align: middle; ' valign='middle'><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; ' width='100%'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 0 10px; padding-top: 18px; word-break: break-word; '><div data-gmail-template='text-slot' style=' font-family: arial,sans-serif; font-size: 15px; font-weight: 400; letter-spacing: 0; line-height: 1.4; text-align: left; color: #5F6368; ' contenteditable='true' tabindex='1' role='textbox' class='anG TbVst'>Contraseña: {{Contraseña}}</div></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td><td></td></tr><tr height='0'><td colwidth='3'><span style='padding-top: 0; font-size: 0; line-height: 0; color: #000000; background-color: #000000; mso-hide: all; display: none; overflow: hidden; max-height: 0;' data-gmail-template='collapse-fix'>ev9m7yvfgf3j</span></td></tr></tbody></table>"
      Body = Body.replace("{{Contraseña}}", contrasena)
      const raw = JSON.stringify({
        "html": Body,
        "to": correo,
        "subject": asunto
      });
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      fetch("https://consumos.talsa.com.co/api/talsa/v1/enviarCorreos", requestOptions)
        .then(response => response.text())
        .then(result => {
          if (JSON.parse(result).mensaje === "Correo enviado exitosamente") {
            resolve("true")
          } else {
            resolve("false")
          }
        })
        .catch(error => console.log('error', error));
    })

  })

}


export async function EnviarCorreoPersonalizado(correo, asunto, body) {
  return new Promise((resolve) => {
    loginauth().then((token) => {
      const myHeaders = new Headers();
      /*let Imagen = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAi8AAAAvCAIAAACkKb06AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADHSURBVHhe7dUxAQAgDMCwgX/P48FDn+SphJ7dHQBI3V8A6LgRAD03AqDnRgD03AiAnhsB0HMjAHpuBEDPjQDouREAPTcCoOdGAPTcCICeGwHQcyMAem4EQM+NAOi5EQA9NwKg50YA9NwIgJ4bAdBzIwB6bgRAz40A6LkRAD03AqDnRgD03AiAnhsB0HMjAHpuBEDPjQDouREAPTcCoOdGAPTcCICeGwHQcyMAem4EQM+NAOi5EQA9NwKg50YA9NwIgJ4bAVCbeZB+A1vrP7hFAAAAAElFTkSuQmCC";
      Imagen = Imagen.replace("data:image/png;base64,", "")*/
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("authorization", token);
      const raw = JSON.stringify({
        "html": body,
        "to": correo,
        "subject": asunto
      });
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      fetch("https://consumos.talsa.com.co/api/talsa/v1/enviarCorreos", requestOptions)
        .then(response => response.text())
        .then(result => {
          if (JSON.parse(result).mensaje === "Correo enviado exitosamente") {
            resolve("true")
          } else {
            resolve("false")
          }
        })
        .catch(error => console.log('error', error));
    })

  })

}

export async function loginauth() {
  return new Promise((resolve) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "username": "programadorit",
      "password": "Slackintosh12042024#",
    });
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch(`${URL_CONSUMOS}/api/talsa/v1/login`, requestOptions)
      .then(response => response.text())
      .then(result => {
        resolve(JSON.parse(result).token)
      })
      .catch(error => console.log('error', error));
  })

}



export async function EnviarCorreoNotificacion(correo, proveedor, id, vector) {
  return new Promise((resolve) => {
    loginauth().then((token) => {
      var excludedColumns = ['idradicado', 'id', 'radicado', 'comentario', 'causa', 'plan'];
      var htmlTable = "<table style='border-collapse: collapse;' border='1'><thead><tr>";
      Object.keys(vector[0]).forEach(function (key) {
        if (!excludedColumns.includes(key)) {
          if (key.includes("estado")) {
            key = key.replace("estado", "Detalle")
            key = key.replace("DetalleCheck", "Progreso")
            htmlTable += "<th style=' width: 80px;' >" + key.replace("DetalleCheck", "Progreso") + "</th>";
          } else {
            key = key.replace("pregunta", "Pregunta")
            key = key.replace("observacion", "Observación")
            htmlTable += "<th  >" + key + "</th>";
          }
        }
      });
      htmlTable += "</tr></thead><tbody>";
      vector.forEach(function (obj) {
        htmlTable += "<tr>";
        Object.keys(obj).forEach(function (key) {
          if (!excludedColumns.includes(key)) {
            if (key == "estado") {
              htmlTable += "<td align= 'center ' bgcolor= '#b63840 ' role= 'presentation ' style= 'border-collapse:collapse;background:#b63840;border:none ' valign= 'middle '><a href= 'http://workmanager.citalsa.com/Publicar/Publicar/InfoDocumento?idRegistro=" + obj[key] + "&idFormulario=10240#no-back-button' style= 'display:inline-block;background:#b63840;color:#ffffff;font-family:tahoma,sans-serif;font-size:14px;font-weight:bold;line-height:1.4;letter-spacing:0;margin:0;text-decoration:none;text-transform:none ' target= '_blank ' data-saferedirecturl= 'https://www.google.com/url?q=https://www.google.com/&amp;source=gmail&amp;ust=1689177777369000&amp;usg=AOvVaw1peAmX-DI-BM-BU-22Uc_J '><span style= 'display:block;min-width:10px '>Ver</span></a></td>";
            } else if (key == "estadoCheck" || key == "estado") {
              const color = obj[key] == 'True' ? '#008238' : '#b63840';
              htmlTable += "<td align= 'center ' bgcolor= '" + color + "' role= 'presentation ' style= 'border-collapse:collapse;background:" + color + ";border:none ' valign= 'middle '> <span style= 'display:block;min-width:10px '> </span></a></td>";
            } else if (key == "fechavencimiento") {
              htmlTable += "<td>" + obj[key].toString().replace("00:00:00", "") + "</td>";
            } else {
              htmlTable += "<td>" + obj[key] + "</td>";
            }
          }
        });
        htmlTable += "</tr>";
      });
      htmlTable += "</tbody></table>";
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("authorization", token);
      let Body = "<table style='background-color: #b63840; padding: 0 20px !important;' role='presentation' width='100%' border='0' cellspacing='0' cellpadding='0' data-gmail-template='body' contenteditable='false'><tbody><tr height='0'><td colspan='3'><span style='padding-top: 0; font-size: 0; line-height: 0; color: #b63840; background-color: #b63840; mso-hide: all; display: none; overflow: hidden; max-height: 0;' data-gmail-template='preview-text'></span></td></tr><tr><td></td><td align='center' valign='top' width='600'><table width='1500' border='0' cellspacing='0' cellpadding='0' style='width: 100%; max-width: 1000px; width: 1000px;  background-color: #b63840;' bgcolor='#b63840' role='presentation'><tbody><tr><td data-gmail-template='content-parent'><style>@media only screen and (max-width: 480px) { .oEQ55c { width: 100% !important;} .zhwgeb { width: auto !important;} .MHCHNe { max-width: 100% !important;} } </style><table width='100%' border='0' cellspacing='0' cellpadding='0' role='presentation'><tbody><tr><td><table data-gmail-template='header' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: collapse; background: #fff; background-color: #fff; width: 100%; ' bgcolor='#fff' width='100%' aria-label='Encabezado' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; background-color: #fff; vertical-align: top; ' width='100%' bgcolor='#fff' valign='top'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 26px 20px; word-break: break-word; '><img data-surl='cid:ii_lj8osz4m0' src='https://d1fdloi71mui9q.cloudfront.net/6tuSuxn4QaC92j4NFEyW_20FUb74K913CBcZY' alt='Logotipo' data-gmail-template='logo-image' style='-ms-interpolation-mode: bicubic; display: block; width: auto; max-width: 200px; height: auto; max-height: 100px; outline: none; text-decoration: none;' width='100' height='100' tabindex='1' draggable='false' class='lCsUvc aog TbVst'></td></tr></tbody></table></div></td></tr></tbody></table></td></tr></tbody></table><table width='100%' border='0' cellspacing='0' cellpadding='0' role='presentation'><tbody><tr><td><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: collapse; background-color: white; width: 100%; ' bgcolor='white' width='100%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding-bottom: 30px; text-align: center; ' align='center'><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' width='100%' style='border-collapse: collapse'><tbody><tr><td style=' border-collapse: collapse; vertical-align: middle; ' valign='middle'><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; ' width='100%'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 0 10px;word-break: break-word; '><div data-gmail-template='text-slot' style=' font-family: tahoma,sans-serif; font-weight: 400; font-size: 32px; letter-spacing: 0; line-height: normal; text-align: center; color: #202124; ' contenteditable='true' tabindex='1' role='textbox' class='anG TbVst'>Revisión de plan de acción:&nbsp;<br>{Proveedor}-{Evaluacion}</div></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' width='100%' style='border-collapse: collapse'><tbody><tr><td style=' border-collapse: collapse; vertical-align: middle; ' valign='middle'><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; ' width='100%'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 0 10px; padding-top: 18px; word-break: break-word; '><div data-gmail-template='text-slot' style=' font-family: tahoma,sans-serif; font-size: 15px; font-weight: 400; letter-spacing: 0; line-height: 1.4; text-align: left; color: #5F6368; ' contenteditable='true' tabindex='1' role='textbox' class='anG TbVst'><span style='color: rgb(55, 65, 81); font-family: Söhne, ui-sans-serif, system-ui, -apple-system, &quot;Segoe UI&quot;, Roboto, Ubuntu, Cantarell, &quot;Noto Sans&quot;, sans-serif, &quot;Helvetica Neue&quot;, Arial, &quot;Apple Color Emoji&quot;, &quot;Segoe UI Emoji&quot;, &quot;Segoe UI Symbol&quot;, &quot;Noto Color Emoji&quot;; font-size: 16px; white-space-collapse: preserve; background-color: rgb(247, 247, 248);'>Recuerda el compromiso desde los sistemas integrados de gestión , Calidad y OEA el obligatorio cumplimiento. Si tiene sugerencias en cantidades o precios dirigirse al portal de <a href='proveedores.citalsa.com:92'> proveedores </a>  </span> {tabla} </div></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; vertical-align: top; ' width='100%' valign='top'><tbody><tr><td align='center' vertical-align='middle' style=' border-collapse: collapse; font-size: 0; padding: 0; padding-top: 30px; word-break: break-word; '><table data-gmail-template='button' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: separate; background: #b63840; border-radius: 4px; line-height: 100%; padding: 8px 24px; ' contenteditable='false' aria-label='Botón' tabindex='-1' class='anE TbVst Vrbnqb'><tbody><tr><td align='center' bgcolor='#b63840' role='presentation' style=' border-collapse: collapse; background: #b63840; border: none; cursor: auto; ' valign='middle'><a href='http://proveedores.citalsa.com:92/' style=' display: inline-block; background: #b63840; color: #ffffff; font-family: tahoma,sans-serif; font-size: 14px; font-weight: bold; line-height: 1.4; letter-spacing: 0; margin: 0; text-decoration: none; text-transform: none; ' target='_blank' draggable='false' class='dQm01 OIDgAc zDnK4d sLNPec'><span data-gmail-template='button-label' style='display: block; min-width: 10px' contenteditable='true' tabindex='1' class='anF'>Ir al portal</span></a></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td><td></td></tr><tr height='0'><td colwidth='3'><span style='padding-top: 0; font-size: 0; line-height: 0; color: #b63840; background-color: #b63840; mso-hide: all; display: none; overflow: hidden; max-height: 0;' data-gmail-template='collapse-fix'>p0rb7yiou7wc</span></td></tr></tbody></table>"
      Body = Body.replace("{Proveedor}", proveedor)
      Body = Body.replace("{Proveedorv2}", proveedor)
      Body = Body.replace("{Evaluacion}", id)
      Body = Body.replace("{tabla}", htmlTable)

      const raw = JSON.stringify({
        "html": Body,
        "to": correo,
        "subject": `${"Alerta de evaluación proveedor: " + proveedor}`
      });
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://consumos.talsa.com.co/api/talsa/v1/enviarCorreos", requestOptions)
        .then(response => response.text())
        .then(result => {
          resolve(result)
        })
        .catch(error => console.log('error', error));
    })
  })
}

export async function ActualizarDatos(radicado, contrasena) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=alnw5hjxiz4lm5fkgvqckttv");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "FCSCP29",
      "Filter": `C0004 = '${radicado}'`,
      "Data": [
        {
          "Field": "C0015",
          "Value": `${contrasena}`,
          "Key": ""
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false,
      "FilterParameters": {
        "Field": "",
        "Operator": "",
        "Value": ""
      }
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Update", requestOptions)
      .then(response => response.text())
      .then(result => {
        resolve(result)
      })
      .catch(error => console.log('error', error));
  })
}

export async function TraerProveedores(Codigo) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "FCSCP29",
      "Filter": `C0003 like '%${toUpper(Codigo)}%'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "10",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        let Vector = [];
        const jsonStr = JSON.parse(result).Data;
        const registros = [];
        let registroActual = {};
        for (let i = 0; i < jsonStr.length; i += +1) {
          const item = jsonStr[i];
          if (item.Key === 'Cod_Barras' && item.Field === 'Radicado') {
            if (Object.keys(registroActual).length > 0) {
              registros.push({ id: registroActual["ID SAP"], label: `${registroActual["ID SAP"]}-${registroActual["RAZON SOCIAL"]}` });
              Vector = [...Vector, [{ id: registroActual["ID SAP"], label: `${registroActual["ID SAP"]}-${registroActual["RAZON SOCIAL"]}` }]]
              registroActual = {};
            }
          }
          registroActual[item.Field] = item.Value;
          if (i === jsonStr.length - 1) {
            registros.push(registroActual);
          }
        }
        resolve(registros)
      })
      .catch(error => console.log('error', error));
  })
}


export async function TraerDatosFL16(Codigo) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "FCSCP34",
      "Filter": `Cod_Barras = 'FCSCP34-01-${localStorage.RadicadoFL16}'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "10",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;
        console.log(jsonStr)
        if (jsonStr.length <= 0) {
          resolve([])
        } else {
          resolve(jsonStr[21].Value)
        }
      })
      .catch(error => console.log('error', error));
  })
}


export async function ModificarFL16(Radicado, Datos) {
  return new Promise((resolve) => {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=alnw5hjxiz4lm5fkgvqckttv");
    const raw = JSON.stringify({
      "OperationUser": "PROGRAMADORIT",
      "FormCode": "FCSCP34",
      "Filter": `Cod_Barras = 'FCSCP34-01-${Radicado}'`,
      "Data": [
        {
          "Field": "C0023",
          "Value": `${Datos}`,
          "Key": ""
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false,
      "FilterParameters": {
        "Field": "",
        "Operator": "",
        "Value": ""
      }
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    console.log(raw)
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Update", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(error => console.log('error', error));
  })
}


export async function InsertFormFL16(Radicado, Datos) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=alnw5hjxiz4lm5fkgvqckttv");
    const raw = JSON.stringify(
      {
        "OperationUser": "PROGRAMADORIT",
        "BarCode": `FCSCP34-01-${Radicado}`,
        "Files": [
          {
            "Base64String": `${Datos}`,
            "Ext": ".docx",
            "Description": "documento FL16",
            "DocumentTypeCode": "00",
            "DirectoryCode": "05",
            "Version": "1"
          }
        ],
        "Header": {
          "User": "Citalsa",
          "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
        }
      }
    );

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    console.log(raw)
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_AttachFiles", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          resolve(true)
        } else {
          resolve(false)
        }
      }).catch(error => console.log('error', error));
  })
}



export async function TraerRadicadoFL16(Codigo) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "FCSCP34",
      "Filter": `Radicado like '%${toUpper(Codigo)}%'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "10",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        let Vector = [];
        const jsonStr = JSON.parse(result).Data;
        const registros = [];
        let registroActual = {};
        for (let i = 0; i < jsonStr.length; i += +1) {
          const item = jsonStr[i];
          if (item.Key === 'Cod_Barras' && item.Field === 'Radicado') {
            if (Object.keys(registroActual).length > 0) {
              console.log(registroActual)
              registros.push({ id: registroActual["Radicado"], label: `${registroActual["NÚMERO DE CONSECUTIVO"]}-${registroActual["PROVEEDOR O CLIENTE"]}-${registroActual["Fecha"].split(' ')[0].replace(/-/g, '')}${registroActual["NÚMERO DE CONSECUTIVO"]}` });
              Vector = [...Vector, [{ id: registroActual["Radicado"], label: `${registroActual["NÚMERO DE CONSECUTIVO"]}-${registroActual["PROVEEDOR O CLIENTE"]}-${registroActual["Fecha"].split(' ')[0].replace(/-/g, '')}${registroActual["NÚMERO DE CONSECUTIVO"]}` }]]
              registroActual = {};
              console.log(registros)
            }
          }
          registroActual[item.Field] = item.Value;
          if (i === jsonStr.length - 1) {
            registros.push(registroActual);
          }
        }
        resolve(registros)
      })
      .catch(error => console.log('error', error));
  })
}


export async function EnviarCorreopdf(pdf, correo, razonSocial, asunto) {
  return loginauth().then((token) => {

    return new Promise((resolve) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("authorization", token);
      let Body = "<table style='background-color: #b63840; padding: 0 20px !important;' role='presentation' width='100%' border='0' cellspacing='0' cellpadding='0' data-gmail-template='body' contenteditable='false'><tbody><tr height='0'><td colspan='3'><span style='padding-top: 0; font-size: 0; line-height: 0; color: #b63840; background-color: #b63840; mso-hide: all; display: none; overflow: hidden; max-height: 0;' data-gmail-template='preview-text'></span></td></tr><tr><td></td><td align='center' valign='top' width='600'><table width='600' border='0' cellspacing='0' cellpadding='0' style='width: 100%; max-width: 600px;background-color: #b63840;' bgcolor='#b63840' role='presentation'><tbody><tr><td data-gmail-template='content-parent'><style>@media only screen and (max-width: 480px) { .oEQ55c { width: 100% !important;} .zhwgeb { width: auto !important;} .MHCHNe { max-width: 100% !important;} } </style><table width='100%' border='0' cellspacing='0' cellpadding='0' role='presentation'><tbody><tr><td><table data-gmail-template='header' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: collapse; background: #fff; background-color: #fff; width: 100%; ' bgcolor='#fff' width='100%' aria-label='Encabezado' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; background-color: #fff; vertical-align: top; ' width='100%' bgcolor='#fff' valign='top'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 26px 20px; word-break: break-word; '><img data-surl='cid:ii_lj8osz4m0' src='https://d1fdloi71mui9q.cloudfront.net/6tuSuxn4QaC92j4NFEyW_20FUb74K913CBcZY' alt='Logotipo' data-gmail-template='logo-image' style='-ms-interpolation-mode: bicubic; display: block; width: auto; max-width: 200px; height: auto; max-height: 100px; outline: none; text-decoration: none;' width='100' height='100' tabindex='1' draggable='false' class='lCsUvc aog TbVst'></td></tr></tbody></table></div></td></tr></tbody></table></td></tr></tbody></table><table width='100%' border='0' cellspacing='0' cellpadding='0' role='presentation'><tbody><tr><td><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: collapse; background-color: white; width: 100%; ' bgcolor='white' width='100%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding-bottom: 30px; text-align: center; ' align='center'><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' width='100%' style='border-collapse: collapse'><tbody><tr><td style=' border-collapse: collapse; vertical-align: middle; ' valign='middle'><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; ' width='100%'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 0 10px;word-break: break-word; '><div data-gmail-template='text-slot' style=' font-family: tahoma,sans-serif; font-weight: 400; font-size: 32px; letter-spacing: 0; line-height: normal; text-align: center; color: #202124; ' contenteditable='true' tabindex='1' role='textbox' class='anG TbVst'>Revisión de plan de acción:&nbsp;<br>{Proveedorv2}-{Evaluacion}</div></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: middle; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' width='100%' style='border-collapse: collapse'><tbody><tr><td style=' border-collapse: collapse; vertical-align: middle; ' valign='middle'><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; ' width='100%'><tbody><tr><td align='center' style=' border-collapse: collapse; font-size: 0; padding: 0 10px; padding-top: 18px; word-break: break-word; '><div data-gmail-template='text-slot' style=' font-family: tahoma,sans-serif; font-size: 15px; font-weight: 400; letter-spacing: 0; line-height: 1.4; text-align: left; color: #5F6368; ' contenteditable='true' tabindex='1' role='textbox' class='anG TbVst'><span style='color: rgb(55, 65, 81); font-family: Söhne, ui-sans-serif, system-ui, -apple-system, &quot;Segoe UI&quot;, Roboto, Ubuntu, Cantarell, &quot;Noto Sans&quot;, sans-serif, &quot;Helvetica Neue&quot;, Arial, &quot;Apple Color Emoji&quot;, &quot;Segoe UI Emoji&quot;, &quot;Segoe UI Symbol&quot;, &quot;Noto Color Emoji&quot;; font-size: 16px; white-space-collapse: preserve; background-color: rgb(247, 247, 248);'>Adjunto encontrará el soporte de la visita realizada a el proveedor {Proveedor} con fecha de {Fecha}. Recuerde el compromiso desde los sistemas integrados de gestión, calidad y OEA, el cual es de obligatorio cumplimiento. </span></div></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table><table data-gmail-template='section' align='center' border='0' cellpadding='0' cellspacing='0' role='region' style='border-collapse: collapse; display: inline-table' width='80%' aria-label='Sección' class='Vrbnqb'><tbody><tr><td style=' border-collapse: collapse; direction: ltr; font-size: 0; padding: 0; text-align: center; ' align='center'><div style=' font-size: 0; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%; '><table border='0' cellpadding='0' cellspacing='0' role='presentation' style=' border-collapse: collapse; vertical-align: top; ' width='100%' valign='top'><tbody><tr><td align='center' vertical-align='middle' style=' border-collapse: collapse; font-size: 0; padding: 0; padding-top: 30px; word-break: break-word; '><table data-gmail-template='button' border='0' cellpadding='0' cellspacing='0' role='region' style=' border-collapse: separate; background: #b63840; border-radius: 4px; line-height: 100%; padding: 8px 24px; ' contenteditable='false' aria-label='Botón' tabindex='-1' class='anE TbVst Vrbnqb'><tbody><tr><td align='center' bgcolor='#b63840' role='presentation' style=' border-collapse: collapse; background: #b63840; border: none; cursor: auto; ' valign='middle'><a href='http://proveedores.citalsa.com:92/' style=' display: inline-block; background: #b63840; color: #ffffff; font-family: tahoma,sans-serif; font-size: 14px; font-weight: bold; line-height: 1.4; letter-spacing: 0; margin: 0; text-decoration: none; text-transform: none; ' target='_blank' draggable='false' class='dQm01 OIDgAc zDnK4d sLNPec'><span data-gmail-template='button-label' style='display: block; min-width: 10px' contenteditable='true' tabindex='1' class='anF'>Visitas proveedores</span></a></td></tr></tbody></table></td></tr></tbody></table></div></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td><td></td></tr><tr height='0'><td colwidth='3'><span style='padding-top: 0; font-size: 0; line-height: 0; color: #b63840; background-color: #b63840; mso-hide: all; display: none; overflow: hidden; max-height: 0;' data-gmail-template='collapse-fix'>p0rb7yiou7wc</span></td></tr></tbody></table>"
      Body = Body.replace("{Proveedor}", razonSocial)
      Body = Body.replace("{Proveedorv2}", razonSocial)
      Body = Body.replace("{Evaluacion}", "")


      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Sumar 1 ya que los meses van de 0 a 11
      const year = currentDate.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      Body = Body.replace("{Fecha}", formattedDate)

      const raw = JSON.stringify({
        "html": Body,
        "to": correo,
        "pdf": pdf,
        "subject": `${asunto + ": " + razonSocial}`
      });
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch("https://consumos.talsa.com.co/api/talsa/v1/enviarCorreospdf", requestOptions)
        .then(response => response.text())
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          console.log('error', error);
          resolve("false");
        });

    })
  })
}

export async function TareasProveedor(Proveedor, fechaDiligenciamiento, pais, razonSocial, direccion, vinculosCiTalsa, ciudad, opcionSeleccionada, jsonData, proveedortexto) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "IT01",
      "OfficeCode": "01",
      "nextStepUser": "comercioint",
      "ProcessId": 1214,
      "Data": [
        {
          "Field": "C0001",
          "Value": `${Proveedor}`,
          "Key": ""
        }, {
          "Field": "C0002",
          "Value": `${fechaDiligenciamiento}`,
          "Key": ""
        }, {
          "Field": "C0003",
          "Value": `${pais}`,
          "Key": ""
        }, {
          "Field": "C0004",
          "Value": `${razonSocial}`,
          "Key": ""
        }, {
          "Field": "C0005",
          "Value": `${direccion}`,
          "Key": ""
        }, {
          "Field": "C0006",
          "Value": `${vinculosCiTalsa}`,
          "Key": ""
        }, {
          "Field": "C0007",
          "Value": `${ciudad}`,
          "Key": ""
        }, {
          "Field": "C0008",
          "Value": `${opcionSeleccionada}`,
          "Key": ""
        }, {
          "Field": "C0009",
          "Value": `${jsonData}`,
          "Key": ""
        }, {
          "Field": "C0010",
          "Value": `${proveedortexto}`,
          "Key": ""
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": true
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Insert", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          swal(`Ingreso la información con exito`, "GRACIAS!", "success");

          resolve(JSON.parse(result))
        } else {
          swal("No se inserto el RADICADO del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}


export async function ingresoDOCXWorkmanagerFlujo(Dato, id, nombre) {
  return new Promise((resolve) => {
    // Limpia cualquier prefijo de "data:[mime-type];base64,"
    if (Dato && Dato.includes("base64,")) {
      Dato = Dato.split("base64,")[1];
    }
    const raw = JSON.stringify(
      {
        "OperationUser": "CPENUELA",
        "WorkflowId": id,
        "CopyToForm": true,
        "Files": [
          {
            "Base64String": `${Dato}`,
            "Ext": ".docx",
            "Description": `${nombre}`,
            "DocumentTypeCode": "00",
            "DirectoryCode": "00",
            "Version": "1"
          }
        ]
      });

    fetchWorkmanager("Workflow/Workflow_AttachFiles", raw)
      .then(response => response.text())
      .then(result => {
        console.log("Response DOCX/PDF Workflow Upload (Raw):", result);
        if (JSON.parse(result).Success === true) {
          resolve(JSON.parse(result).Success)
          swal("Inserto el PDF...!", "Espere que salgan las demás alertas!", "success");
        } else {
          swal("No se inserto el PDF del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}


export async function ingresoPDFWorkmanagerFlujo(Dato, id) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=alnw5hjxiz4lm5fkgvqckttv");
    Dato = Dato.replace("data:application/pdf;base64,", "")
    Dato = Dato.replace("data:image/png;base64,", "")

    const raw = JSON.stringify(
      {
        "OperationUser": "CPENUELA",
        "WorkflowId": id,
        "CopyToForm": true,
        "Files": [
          {
            "Base64String": `${Dato}`,
            "Ext": ".pdf",
            "Description": "Evaluación",
            "DocumentTypeCode": "00",
            "DirectoryCode": "00",
            "Version": "1"
          }
        ],
        "Header": {
          "User": "Citalsa",
          "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
        }
      });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Workflow/Workflow_AttachFiles", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          resolve(JSON.parse(result).Success)
          swal("Inserto el PDF...!", "Espere que salgan las demás alertas!", "success");
        } else {
          swal("No se inserto el PDF del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}


export async function TareasProveedorObseracion(Proveedor, comentario, observacion, radicado, pregunta, fecha) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "IT02",
      "OfficeCode": "01",
      //"nextStepUser": "CPENUELA",
      //"ProcessId": 1218,
      "Data": [
        {
          "Field": "C0001",
          "Value": `${Proveedor}`,
          "Key": ""
        }, {
          "Field": "C0002",
          "Value": `${comentario}`,
          "Key": ""
        }, {
          "Field": "C0003",
          "Value": `${observacion}`,
          "Key": ""
        }, {
          "Field": "C0005",
          "Value": `${radicado}`,
          "Key": ""
        }, {
          "Field": "C0006",
          "Value": `${pregunta}`,
          "Key": ""
        }, {
          "Field": "C0010",
          "Value": `${fecha}`,
          "Key": ""
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": true
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Insert", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          swal(`Ingreso la información con exito`, "GRACIAS!", "success");

          resolve(JSON.parse(result))
        } else {
          swal("No se inserto el RADICADO del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}

export async function VisitasProveedor() {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "IT01",
      "Filter": `C0001 like '%${localStorage.Proveedor}%'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "100",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;

        const registros = [];
        let registroActual = [];
        for (const item of jsonStr) {
          registroActual.push({ id: item.Field, Value: item.Value })
          if (item.Field == "Radicado") {
            registroActual.push({ id: item.Field, Value: item.Value })
            registros.push(registroActual)
            registroActual = [];
          }
        }
        resolve(registros)
      })
      .catch(error => console.log('error', error));
  })
}

export async function VisitasProveedorAll() {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "IT01",
      "Filter": `C0001 like '%0%'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "500",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;

        const registros = [];
        let registroActual = [];
        for (const item of jsonStr) {
          registroActual.push({ id: item.Field, Value: item.Value })
          if (item.Field == "Radicado") {
            registroActual.push({ id: item.Field, Value: item.Value })
            registros.push(registroActual)
            registroActual = [];
          }
        }
        resolve(registros)
      })
      .catch(error => console.log('error', error));
  })
}


export async function VisitasProveedorObservaciones(radicado) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=skmlytzma1ztmlaph0bb42ol");
    const raw = JSON.stringify({
      "FormCode": "IT02",
      "Filter": `C0005 like '%${radicado}%'`,
      "OrderColumn": "",
      "OrderType": "",
      "Top": "100",
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_GetData", requestOptions)
      .then(response => response.text())
      .then(result => {
        const jsonStr = JSON.parse(result).Data;

        const registros = [];
        let registroActual = [];
        for (const item of jsonStr) {
          registroActual.push({ id: item.Field, Value: item.Value })
          if (item.Field == "Radicado") {
            registroActual.push({ id: item.Field, Value: item.Value })
            registros.push(registroActual)
            registroActual = [];
          }
        }

        let vector = [];
        registros.forEach(elementv2 => {
          vector.push({
            idradicado: elementv2[4].Value, pregunta: elementv2[5].Value, id: Math.random(), comentario: elementv2[1].Value, observacion: elementv2[2].Value,
            radicado: elementv2[12].Value, causa: elementv2[3].Value, plan: elementv2[6].Value,
            estadoCheck: elementv2[7].Value, estado: elementv2[10].Value, fechavencimiento: elementv2[8].Value
          })
        });
        resolve(vector)
      })
      .catch(error => console.log('error', error));
  })
}


export async function updateObservacion(causa, plan, radicado) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ASP.NET_SessionId=alnw5hjxiz4lm5fkgvqckttv");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "IT02",
      "Filter": `Cod_Barras = '${radicado}'`,
      "Data": [
        {
          "Field": "C0004",
          "Value": `${causa}`,
          "Key": ""
        }, {
          "Field": "C0007",
          "Value": `${plan}`,
          "Key": ""
        }
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": false,
      "FilterParameters": {
        "Field": "",
        "Operator": "",
        "Value": ""
      }
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Update", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          swal(`Ingreso la información con exito`, "GRACIAS!", "success");
          resolve(JSON.parse(result).Success)
        } else {
          swal("No se inserto el RADICADO del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}


export async function EvaluacionProveedor(codigoInternoProveedor, nombreProveedor, tipoDocumento, numeroDocumento, direccion, prestadorBienesServicios,
  evaluador, cargo, categoria, fechaEvaluacion, periodoEvaluado, correoProveedor, jsonData, observacion) {
  return new Promise((resolve) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
      "OperationUser": "CPENUELA",
      "FormCode": "IT03",
      "OfficeCode": "01",
      "nextStepUser": "jeospina",
      "ProcessId": 1220,
      "Data": [
        {
          "Field": "C0001",
          "Value": `${codigoInternoProveedor}`,
          "Key": ""
        }, {
          "Field": "C0002",
          "Value": `${nombreProveedor}`,
          "Key": ""
        }, {
          "Field": "C0003",
          "Value": `${tipoDocumento}`,
          "Key": ""
        }, {
          "Field": "C0004",
          "Value": `${numeroDocumento}`,
          "Key": ""
        }, {
          "Field": "C0005",
          "Value": `${direccion}`,
          "Key": ""
        }, {
          "Field": "C0006",
          "Value": `${prestadorBienesServicios}`,
          "Key": ""
        }, {
          "Field": "C0007",
          "Value": `${evaluador}`,
          "Key": ""
        }, {
          "Field": "C0008",
          "Value": `${cargo}`,
          "Key": ""
        }, {
          "Field": "C0009",
          "Value": `${categoria}`,
          "Key": ""
        }, {
          "Field": "C0010",
          "Value": `${fechaEvaluacion}`,
          "Key": ""
        }, {
          "Field": "C0011",
          "Value": `${periodoEvaluado}`,
          "Key": ""
        }, {
          "Field": "C0012",
          "Value": `${correoProveedor}`,
          "Key": ""
        }, {
          "Field": "C0013",
          "Value": `${jsonData}`,
          "Key": ""
        }, {
          "Field": "C0014",
          "Value": `${observacion}`,
          "Key": ""
        },
      ],
      "Header": {
        "User": "Citalsa",
        "Token": "SjadcevovIaTug8bfnSeHWPBQIkM50ZH"
      },
      "CheckWorkflow": true
    });


    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch("https://workmanager.citalsa.com:91/api/Forms/Form_Insert", requestOptions)
      .then(response => response.text())
      .then(result => {
        if (JSON.parse(result).Success === true) {
          swal(`Ingreso la información con exito`, "GRACIAS!", "success");

          resolve(JSON.parse(result))
        } else {
          swal("No se inserto el RADICADO del registro!", "Valide la información!", "warning");
        }
      })
      .catch(error => console.log('error', error));
  })
}

function convertirFecha(timestamp) {
  let timeValue;
  if (typeof timestamp === 'string') {
    const match = timestamp.match(/\d+/);
    timeValue = match ? parseInt(match[0]) : NaN;
  } else {
    timeValue = parseInt(timestamp);
  }
  if (isNaN(timeValue)) {
    return new Date('Invalid Date');
  }
  if (timeValue < 10000000000) {
    return new Date(timeValue * 1000); // Es en segundos, convertir a milisegundos
  }
  return new Date(timeValue);
}


function getDateInSeconds() {
  const now = Date.now(); // Fecha actual en milisegundos
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000; // Un día en milisegundos
  const yesterday = now - oneDayInMilliseconds; // Restar un día
  return yesterday;
}

export async function updatePasswordBigQuery(usuario, contrasena) {
  try {
    const response = await fetch('https://consumos.talsa.com.co/api/talsa/proveedores/change-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usuario, contrasena }),
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errorData = await response.json().catch(() => ({}));
      return { success: false, error: errorData };
    }
  } catch (error) {
    console.error('Error updating password in BigQuery:', error);
    return { success: false, error: error.message };
  }
}

export async function pagosGet(fechaInicio, fechaFin) {
  try {
    const proveedorId = localStorage.Proveedor; // Ensure this is set in localStorage
    console.log("Fetching pagos for provider:", proveedorId);

    // Use the confirmed endpoint, dynamically passing the provider ID
    const response = await fetch(`https://consumos.talsa.com.co/api/talsa/proveedores/getpagos?CIM_BP_UUID=${proveedorId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    let data = [];
    if (response.ok) {
      const result = await response.json();
      console.log("Pagos data received:", result);
      // Handle different possible structures (array directly or wrapped in d.results)
      if (Array.isArray(result)) {
        data = result;
      } else if (result.d && result.d.results) {
        data = result.d.results;
      } else if (result.data) { // Some APIs return { data: [...] }
        data = result.data;
      } else {
        data = [];
        console.warn("Unexpected response structure:", result);
      }
    } else {
      console.error("API Pagos error:", response.status);
      // Keep mock data for fallback only if needed for dev without VPN/Access
    }

    // Helper: parsear valores con formato colombiano como "644.867,20 COP"
    // Los puntos son separadores de miles, la coma es decimal
    const parseCOPValue = (val) => {
      if (!val || val === "") return 0;
      // Convertir a string por si acaso
      let str = String(val).trim();
      // Quitar sufijo de moneda (ej: " COP", " USD", " EUR")
      str = str.replace(/\s*[A-Za-z]{3}\s*$/, '');
      // Quitar puntos de miles y reemplazar coma decimal por punto
      str = str.replace(/\./g, '').replace(',', '.');
      const num = parseFloat(str);
      return isNaN(num) ? 0 : num;
    };

    const parsedPayments = [];

    data.forEach(item => {
      const paymentId = item.Numero_Aviso_Pago || "Sin Referencia";
      const totalAmount = parseCOPValue(item.Suma_Total_Importes);
      const currency = item.Moneda || "COP";

      let totalPending = 0;
      let invoices = [];

      if (item.Detalles_Pago && Array.isArray(item.Detalles_Pago)) {
        item.Detalles_Pago.forEach(det => {
          const pending = parseCOPValue(det.Importe_Pendiente);
          const amount = parseCOPValue(det.Importe_Pago);
          totalPending += pending;

          invoices.push({
            invoiceId: det.ID_Factura || "",
            externalReference: det.Referencia_externa || "",
            amount: amount,
            pending: pending,
            currency: currency
          });
        });
      }

      parsedPayments.push({
        id: paymentId,
        date: null,
        totalAmount: totalAmount,
        pendingAmount: totalPending,
        currency: currency,
        status: totalPending > 0 ? "Pendiente" : "Pagado",
        paymentType: "Transferencia / Pago",
        invoices: invoices
      });
    });

    return parsedPayments;

  } catch (error) {
    console.error("Error fetching pagos:", error);
    return [];
  }
}



// ============================================================
// OTP / VERIFICACIÓN DE CORREO PARA ACTIVACIÓN DE CUENTA
// ============================================================

let sessionOtpData = { email: "", code: "", expiresAt: 0 };

export async function enviarCodigoVerificacion(email) {
  try {
    const generatedOTP = Math.floor(100000 + Math.random() * 900000).toString();
    const bodyHtml = `
      <div style="font-family: Arial, sans-serif; max-width: 480px; margin: auto; border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden;">
        <div style="background-color: #BD1F34; padding: 24px; text-align: center;">
          <h1 style="color: white; margin: 0; font-size: 22px;">Portal de Proveedores</h1>
        </div>
        <div style="padding: 32px; background-color: #ffffff;">
          <p style="font-size: 16px; color: #333;">Utilice el siguiente código de verificación para continuar:</p>
          <div style="background-color: #f5f5f5; border-radius: 8px; padding: 20px; text-align: center; margin: 24px 0;">
            <span style="font-size: 42px; font-weight: bold; letter-spacing: 12px; color: #BD1F34;">${generatedOTP}</span>
          </div>
          <p style="font-size: 14px; color: #666;">Este código es válido por <strong>15 minutos</strong>. No lo comparta con nadie.</p>
        </div>
        <div style="background-color: #f9f9f9; padding: 16px; text-align: center;">
          <p style="font-size: 12px; color: #999; margin: 0;">Si no solicitó este código, ignore este mensaje.</p>
        </div>
      </div>
    `;

    const emailStatus = await EnviarCorreoPersonalizado(email, "Código de verificación - Portal Proveedores", bodyHtml);

    if (emailStatus !== "true") {
      return { success: false, message: "Error al enviar el correo con el código." };
    }

    sessionOtpData = {
      email: email,
      code: generatedOTP,
      expiresAt: Date.now() + 15 * 60 * 1000 // 15 minutos
    };

    return { success: true, message: "Código enviado correctamente." };
  } catch (error) {
    console.error("enviarCodigoVerificacion error:", error);
    return { success: false, message: "Error de conexión al enviar el código." };
  }
}

/**
 * Paso 2: Valida el código de 6 dígitos ingresado por el usuario (local).
 */
export async function validarCodigoVerificacion(email, codigo) {
  try {
    if (!sessionOtpData || sessionOtpData.email !== email) {
      return { success: false, message: "No se ha solicitado un código para este correo." };
    }

    if (Date.now() > sessionOtpData.expiresAt) {
      return { success: false, message: "El código ha expirado. Por favor solicite uno nuevo." };
    }

    if (sessionOtpData.code !== codigo) {
      return { success: false, message: "Código incorrecto." };
    }

    // sessionOtpData = null; // Opcional, para que no se use dos veces, pero interfiere si fallan el re-intento de red // Comentado
    return { success: true, message: "Código válido." };
  } catch (error) {
    console.error("validarCodigoVerificacion error:", error);
    return { success: false, message: "Error de conexión al validar el código." };
  }
}

/**
 * Paso 3: Cambia la contraseña del usuario una vez verificado el código OTP.
 */
export async function cambiarContrasena(usuario, newPassword) {
  try {
    const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/change-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ usuario, newPassword })
    });

    const result = await response.json();

    if (!response.ok || result.success === false) {
      return { success: false, message: result.message || "No se pudo cambiar la contraseña." };
    }

    return { success: true, message: "Contraseña actualizada correctamente." };
  } catch (error) {
    console.error("cambiarContrasena error:", error);
    return { success: false, message: "Error de conexión al cambiar la contraseña." };
  }
}

/**
 * Registra o crea el usuario en el backend de BigQuery
 */
export async function registerUser(username, password, email, rol = 'usuario') {
  try {
    const response = await fetch('https://consumos.talsa.com.co/api/talsa/proveedores/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usuario: username, contrasena: password, email, rol }),
    });

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      const errorData = await response.json();
      return { success: false, error: errorData.error };
    }
  } catch (error) {
    console.error('Error en registro:', error);
    return { success: false, error: 'Error de conexión' };
  }
}

/**
 * Verifica el estado de cuenta de un usuario en BigQuery.
 * Hace login con la contraseña temporal conocida para distinguir 3 estados:
 *   1. isActive: true  → tiene contraseña real (puede recuperar contraseña)
 *   2. isActive: false, isLimbo: true  → tiene Temporal123* (empezó activación pero no la terminó)
 *   3. isActive: false, isLimbo: false → no existe en BigQuery (nunca empezó activación)
 */
export async function checkUserExists(usuario) {
  try {
    const response = await fetch('https://consumos.talsa.com.co/api/talsa/proveedores/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: usuario, password: 'Temporal123*' }),
    });

    const data = await response.json().catch(() => ({}));
    const errMsg = (data.error || data.message || '').toLowerCase();

    console.log(`🔍 checkUserExists [${usuario}] → status: ${response.status}, error: "${errMsg}"`);

    // Login exitoso con Temporal123* → usuario está en LIMBO (activación incompleta)
    if (response.ok) {
      const emailEnBigQuery = data.email || data.correo || data.Email || '';
      console.log('⚠️ Usuario en LIMBO. Email en BigQuery:', emailEnBigQuery);
      return { isActive: false, isLimbo: true, email: emailEnBigQuery };
    }

    // Buscar en el mensaje de error si el usuario NO existe
    const noExisteKeywords = ['no encontrado', 'not found', 'no existe', 'does not exist', 'usuario no', 'user not', 'inexistente'];
    const noExiste = noExisteKeywords.some(kw => errMsg.includes(kw)) || response.status === 404;
    if (noExiste) {
      console.log('ℹ️ Usuario no existe en BigQuery.');
      return { isActive: false, isLimbo: false, email: '' };
    }

    // Buscar si el error es claramente de "contraseña incorrecta" (el usuario SÍ existe)
    const wrongPasswordKeywords = ['contraseña', 'password', 'credencial', 'credential', 'incorrect', 'inválid', 'invalid', 'wrong'];
    const wrongPassword = wrongPasswordKeywords.some(kw => errMsg.includes(kw)) || response.status === 401;
    if (wrongPassword) {
      console.log('✅ Usuario tiene cuenta activa con contraseña real.');
      return { isActive: true, isLimbo: false, email: '' };
    }

    // Error no reconocido → por seguridad, asumimos que NO está activo (fail-open)
    // Esto evita bloquear usuarios legítimos cuyo registro fue eliminado de BigQuery
    console.warn(`⚠️ checkUserExists: respuesta no reconocida del servidor (status ${response.status}, msg: "${errMsg}"). Asumiendo NO activo.`);
    return { isActive: false, isLimbo: false, email: '' };

  } catch (error) {
    console.error('Error en checkUserExists:', error);
    return { isActive: false, isLimbo: false, email: '' };
  }
}

/**
 * Actualiza el correo de un usuario existente en BigQuery
 */
export async function actualizarCorreoUsuario(usuario, nuevoEmail) {
  try {
    const response = await fetch('https://consumos.talsa.com.co/api/talsa/proveedores/update-email', {
      method: 'PUT', // o POST, dependiendo de cómo lo haga el backend
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usuario, email: nuevoEmail }),
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errorData = await response.json();
      return { success: false, error: errorData.error || errorData.message || "Error al actualizar" };
    }
  } catch (error) {
    console.error('Error al actualizar correo:', error);
    return { success: false, error: 'Error de conexión' };
  }
}

export async function pagosProveedor() {
  return new Promise((resolve) => {
    let url = "https://my360131.sapbydesign.com/sap/byd/odata/ana_businessanalytics_analytics.svc/RPZ0E5775AE56110A8750BFA4QueryResults?$select=CCI_CLR_TRPIM_TC,TIM_OINV_BTD_TC,CCI_CLR_BTDID,TCI_CLR_TRPIM_TC,KCPAYMENT_AMOUNT,TIM_BP_UUID,CIM_BP_UUID,C1NZ3YBJDZMPT37K5GQX6TKRZ1D,CIM_P_B_BTD_ID,FCCD_AVL_N,CCI_CLR_BY_CURR,CIM_SOURCE_ID,CIM_B_BTD_DATE,KRFINDUEU04_RKF_I_02,KKCI_CLR_BY_A,C1IM_BP_UUIDsBKDIRENTR_UUID&$top=99999&$format=json&$filter=CIM_BP_UUID eq '" + localStorage.Proveedor + "'";
    let urlRetencion = "https://my360131.sapbydesign.com/sap/byd/odata/ana_businessanalytics_analytics.svc/RPZ52E2BBDD24393E474108E9QueryResults?$select=CREF_CIV,CSELLER,TSELLER,FKYFM2IYF1Y_8698288627,FKYFM2IYF1Y_A4461B8DDD,FKYFM2IYF1Y_1ECB1345D8&$top=999999&$format=json&$filter=CSELLER eq '" + localStorage.Proveedor + "'";
    let urlBancos = "https://my360131.sapbydesign.com/sap/byd/odata/ana_businessanalytics_analytics.svc/RPFND_SUP_FINDATA_Q0001QueryResults?$select=CBANK_INTERNAL_ID,TBANK_INTERNAL_ID,CBANK_ACCOUNT_ID,CBP_UUID,TBP_UUID&$top=99999&$format=json&$filter=CBP_UUID eq '" + localStorage.Proveedor + "'";

    loginauth().then((token) => {
      Promise.all([
        GetApp(url, token).catch(e => { console.error(e); return null; }),
        GetApp(urlRetencion, token).catch(e => { console.error(e); return null; }),
        GetApp(urlBancos, token).catch(e => { console.error(e); return null; })
      ]).then(([value, valueRetencion, valueBancos]) => {
        if (!value) {
          resolve([]);
          return;
        }

        const retencionMap = {};
        if (valueRetencion) {
          try {
            const retencionesData = JSON.parse(valueRetencion).d.results;

            const parseFormateado = (val) => {
              if (!val) return 0;
              let strVal = String(val).trim();
              if (strVal.includes(',')) {
                // Si hay coma, es el símbolo decimal (ej. 65.086,00)
                return parseFloat(strVal.replace(/\./g, '').replace(/,/g, '.')) || 0;
              } else {
                // Si no hay coma, los puntos se asumen separadores de miles en COP (ej. 65.086 -> 65086)
                return parseFloat(strVal.replace(/\./g, '')) || 0;
              }
            };

            retencionesData.forEach(r => {
              let ica = parseFormateado(r.FKYFM2IYF1Y_8698288627);
              let iva = parseFormateado(r.FKYFM2IYF1Y_A4461B8DDD);
              let renta = parseFormateado(r.FKYFM2IYF1Y_1ECB1345D8);
              retencionMap[r.CREF_CIV] = ica + iva + renta;
            });
          } catch (e) { console.error("Error parsing retencion", e); }
        }

        const bancosMap = {};
        if (valueBancos) {
          try {
            const bancosData = JSON.parse(valueBancos).d.results;
            bancosData.forEach(b => {
              bancosMap[b.CBANK_INTERNAL_ID] = {
                cuenta: b.CBANK_ACCOUNT_ID,
                nombreBanco: b.TBANK_INTERNAL_ID
              };
            });
          } catch (e) { console.error("Error parsing bancos", e); }
        }

        const pagosAgrupados = {};

        JSON.parse(value).d.results.forEach(element => {
          // Filtrar que solo sean de tipo "Pago"
          if (element.TCI_CLR_TRPIM_TC === 'Pago') {
            const avisoPago = element.CCI_CLR_BTDID;
            const importeCompensado = parseFloat(element.KKCI_CLR_BY_A) || 0;
            const referenciaFactura = element.CIM_P_B_BTD_ID;
            const bancoId = element.C1IM_BP_UUIDsBKDIRENTR_UUID;
            const datosBanco = bancosMap[bancoId] || { cuenta: 'N/A', nombreBanco: 'N/A' };

            if (!pagosAgrupados[avisoPago]) {
              pagosAgrupados[avisoPago] = {
                avisoPago: avisoPago,
                importeTotal: 0,
                monedaPago: element.CCI_CLR_BY_CURR || element.C1NZ3YBJDZMPT37K5GQX6TKRZ1D,
                fechaAviso: element.CIM_B_BTD_DATE ? new Date(Number(element.CIM_B_BTD_DATE.match(/\d+/g)[0])) : null,
                socioComercial: element.TIM_BP_UUID,
                socioComercialId: element.CIM_BP_UUID,
                bancoId: bancoId,
                cuentaBancaria: datosBanco.cuenta,
                nombreBanco: datosBanco.nombreBanco,
                facturasPagadas: []
              };
            }

            // Sumar al total
            pagosAgrupados[avisoPago].importeTotal += importeCompensado;

            // Añadir los detalles de cada factura asociada a este aviso de pago
            pagosAgrupados[avisoPago].facturasPagadas.push({
              referenciaFactura: element.CIM_P_B_BTD_ID,
              importeFactura: importeCompensado,
              valorRetencion: retencionMap[referenciaFactura] || 0,
              descuentoProntoPago: element.FCCD_AVL_N,
              monedaFactura: element.C1NZ3YBJDZMPT37K5GQX6TKRZ1D,
              tipoFacturaOriginal: element.TIM_OINV_BTD_TC,
              idDocumentoOriginal: element.CIM_SOURCE_ID,
              idDocumentoCompensacion: element.CCI_CLR_TRPIM_TC
            });
          }
        });

        // Convertir a un arreglo y generar un id único para las grillas/tablas
        const vector = Object.values(pagosAgrupados).map(pago => ({
          ...pago,
          id: Math.floor(Math.random() * 9999999) + 1
        }));

        resolve(vector);
      }).catch(error => {
        console.error("Error obteniendo pagos de SAP:", error);
        resolve([]);
      });
    }).catch(error => {
      console.error("Error en loginauth:", error);
      resolve([]);
    });
  });
}

export async function certificadosProveedorSAP(fechaInicio, fechaFin, tipoCertificado) {
  return new Promise((resolve) => {
    let cuentasFiltro = "CGLACCT eq '231511' or CGLACCT eq '231512' or CGLACCT eq '231514' or CGLACCT eq '231515' or CGLACCT eq '231516' or CGLACCT eq '231517' or CGLACCT eq '231518' or CGLACCT eq '231519' or CGLACCT eq '231520' or CGLACCT eq '231521' or CGLACCT eq '231522' or CGLACCT eq '231523' or CGLACCT eq '231524' or CGLACCT eq '231525' or CGLACCT eq '231526' or CGLACCT eq '231527' or CGLACCT eq '231528' or CGLACCT eq '231531' or CGLACCT eq '231533' or CGLACCT eq '231534' or CGLACCT eq '231535' or CGLACCT eq '231536' or CGLACCT eq '231537' or CGLACCT eq '231550' or CGLACCT eq '231551' or CGLACCT eq '231552' or CGLACCT eq '231553' or CGLACCT eq '231554' or CGLACCT eq '231555' or CGLACCT eq '231556' or CGLACCT eq '231590' or CGLACCT eq '231591' or CGLACCT eq '238000' or CGLACCT eq '238010' or CGLACCT eq '238011' or CGLACCT eq '238012' or CGLACCT eq '238013' or CGLACCT eq '238014' or CGLACCT eq '238015' or CGLACCT eq '238016' or CGLACCT eq '238017' or CGLACCT eq '238018' or CGLACCT eq '238019' or CGLACCT eq '238020' or CGLACCT eq '238021' or CGLACCT eq '238022' or CGLACCT eq '238023' or CGLACCT eq '238024'";

    // We can also filter by CPOSTING_DATE if provided
    let dateFilter = "";
    if (fechaInicio && fechaFin) {
      // CPOSTING_DATE is usually formatted as YYYY-MM-DD
      // Ensure format is correct: eq or between. Since OData might use datetime or string:
      // Try strict string compare if it's a string, e.g. CPOSTING_DATE ge '2024-01-01' and CPOSTING_DATE le '2024-12-31'
      // Or if not supported, we can filter locally. Let's filter locally for safer date ranges.
    }

    let url = `https://my360131.sapbydesign.com/sap/byd/odata/ana_businessanalytics_analytics.svc/RPZ9B02407D887EEE8802871CQueryResults?$select=CGLACCT,TGLACCT,CPOSTING_DATE,COEDREF_F_ID,FCBALANCE_CURRCOMP,C1QRQ9D93BV2AK2URZ729U8NVHJ,T1QRQ9D93BV2AK2URZ729U8NVHJ,C1R40BOTFXO0GEL05V67UID2EHY&$top=99999&$format=json&$filter=C1QRQ9D93BV2AK2URZ729U8NVHJ eq '${localStorage.Proveedor}' and (${cuentasFiltro})`;

    loginauth().then((token) => {
      GetApp(url, token).then(value => {
        if (!value) {
          resolve([]);
          return;
        }

        const data = JSON.parse(value).d.results;

        const parseFormateado = (val) => {
          if (!val) return 0;
          let strVal = String(val).trim();
          if (strVal.includes(',')) {
            return parseFloat(strVal.replace(/\./g, '').replace(/,/g, '.')) || 0;
          } else {
            return parseFloat(strVal.replace(/\./g, '')) || 0;
          }
        };

        const retencionConfig = {
          "231511": { type: "RTF", pct: 10 },
          "231512": { type: "RTF", pct: 11 },
          "231514": { type: "RTF", pct: 10 },
          "231515": { type: "RTF", pct: 11 },
          "231516": { type: "RTF", pct: 6 },
          "231517": { type: "RTF", pct: 1 },
          "231518": { type: "RTF", pct: 2 },
          "231519": { type: "RTF", pct: 3.5 },
          "231520": { type: "RTF", pct: 1 },
          "231521": { type: "RTF", pct: 4 },
          "231522": { type: "RTF", pct: 2 },
          "231523": { type: "RTF", pct: 3.5 },
          "231524": { type: "RTF", pct: 3.5 },
          "231525": { type: "RTF", pct: 4 },
          "231526": { type: "RTF", pct: 3.5 },
          "231527": { type: "RTF", pct: 3.5 },
          "231528": { type: "RTF", pct: 2.5 },
          "231531": { type: "RTF", pct: 2.5 },
          "231533": { type: "RTF", pct: 6 },
          "231534": { type: "RTF", pct: 3.5 },
          "231535": { type: "RTF", pct: 11 },
          "231536": { type: "RTF", pct: 1 },
          "231537": { type: "RTF", pct: 1 },
          "231550": { type: "RTF", pct: 4 },
          "231551": { type: "RTF", pct: 2.5 },
          "231552": { type: "RTF", pct: 11 },
          "231553": { type: "RTF", pct: 0.40 },
          "231554": { type: "RTF", pct: 4 },
          "231555": { type: "RTF", pct: 2.5 },
          "231556": { type: "RTF", pct: 11 },
          "231590": { type: "IVA", pct: 15 },
          "231591": { type: "IVA", pct: 15 }
        };

        const agrupadoPorCuenta = {};

        data.forEach(item => {
          // Local date testing
          if (fechaInicio && fechaFin && item.CPOSTING_DATE) {
            let dateStr = item.CPOSTING_DATE;
            if (dateStr.includes("/Date(")) {
              dateStr = new Date(parseInt(dateStr.replace("/Date(", "").replace(")/", ""))).toISOString().split('T')[0];
            } else if (dateStr.length >= 10) {
              dateStr = dateStr.substring(0, 10);
            }

            if (dateStr < fechaInicio || dateStr > fechaFin) {
              return; // Skip
            }
          }

          const rawBaseBalance = parseFormateado(item.FCBALANCE_CURRCOMP);
          const cuentaConfig = retencionConfig[item.CGLACCT] || { type: "OTHER", pct: 0 };

          if (!agrupadoPorCuenta[item.CGLACCT]) {
            if (tipoCertificado && cuentaConfig.type !== tipoCertificado) {
              return; // Skip if it doesn't match the selected type
            }
            agrupadoPorCuenta[item.CGLACCT] = {
              id: item.CGLACCT,
              cuentaId: item.CGLACCT,
              cuentaTexto: item.TGLACCT,
              tipo: cuentaConfig.type,
              porcentaje: cuentaConfig.pct,
              valorRetenidoAgregado: 0
            };
          }

          agrupadoPorCuenta[item.CGLACCT].valorRetenidoAgregado += Math.abs(rawBaseBalance);
        });

        const parsedCertificados = Object.values(agrupadoPorCuenta).map(g => {
          // Valor retenido = suma de FCBALANCE_CURRCOMP
          const valorRetenido = g.valorRetenidoAgregado;

          // Base = Valor retenido / (porcentaje / 100) -> Matemáticamente correcto para retenciones en Colombia
          const baseCalulada = g.porcentaje > 0 ? (valorRetenido / (g.porcentaje / 100)) : 0;

          return {
            ...g,
            base: baseCalulada,
            valorRetencion: valorRetenido
          };
        });

        resolve(parsedCertificados);

      }).catch(error => {
        console.error("Error obteniendo certificados de SAP:", error);
        resolve([]);
      });
    }).catch(error => {
      console.error("Error en loginauth:", error);
      resolve([]);
    });
  });
}

